import { memo, useEffect, useRef, useState, useCallback, useMemo, startTransition, forwardRef, useImperativeHandle, } from "react";
import { flushSync } from "react-dom";
import { Scheduler, WeekView, DayView, SchedulerViewSlot, SchedulerHeader, TimeHeaderCell, WorkWeekView, DateHeaderCell, SchedulerProportionalViewItem } from "@progress/kendo-react-scheduler";
import { ContextMenu } from "primereact/contextmenu";
import * as API from "../../../framework/API/api";
import CustomPlanningItemV2 from "../planningPerformanceNew/CustomPlanningItemV2";
import { utility } from "../../../framework/utility/utilityProvider";
import PlanningEditFormWithSlot from "./PlanningEditFormWithSlot";
import PlanningRightSideEditFormWithSlot from "./PlanningRightSideEditFormWithSlot";
import { PlanningHelper } from "../helper/PlanningHelper";
import { APIURL, ApplicationConfigurationKeys, DAYS, ENTITYNAME, LOCALSTORAGE_KEY, LOGEVENT, MODULE, OFFSET, PLANNINGTYPE, PLANNING_DELETE_OPTION, PLATFORMTYPE, PUBLISH_TO, SEGMENT_DETAILS_CREDIT_TYPE, SLOT_DIVISIONS, SLOT_TIMES, SOCKET_ACTION, SOCKET_EVENTS, TOAST_TYPES, TX_MODE, TX_STATUS, } from "../../../framework/constant/constant";
import { useTranslation } from "../../../locale/useTranslation";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import CollectionSelection from "../../../framework/forms/CollectionSelection";
import { useNavigate } from "react-router-dom";
import useSocket from "../../../framework/socket/useSocket";
import { EditPageHeader } from "../../../components/EditPageHeader";
import moment from "moment";
import { ConfirmAlert } from "../../../ConfirmAlert";
import MediaFastSegmentationPopup from "../../Segment/MediaFastSegmentationPopup";
import PlanningEditDummyPopup from "../PlanningEditDummyPopup";
import ContractCollectionSelection from "../../Contract/ContractCollectionSelection";
import PlanningInsertProgramGroup from "../PlanningInsertProgramGroup";
import { Day } from "@progress/kendo-date-math";
import CheckLists from "../../CheckList/CheckLists";
import { Slider, SliderLabel } from "@progress/kendo-react-inputs";
import { TimePickerWithFormat } from "../../../framework/forms/helpercomponents/timepicker/TimePickerWithFormat";
import { MediaDealRights_columns, MediaEpisodeSegment_columns } from "../../../framework/utility/customColumns";
import HeaderLockPopup from "../headerLockPopup";
import BossDialog from "../../../components/BossDialog";
import AmortisationValueReport from "../AmortisationValueReport";
import { SchedulingHelper } from "../../Scheduling/helper/SchedulingHelper";
import PlanningInsertDummyPopup from "../PlanningInsertDummyPopup";
import { v4 as uuidv4 } from 'uuid';
import _ from "underscore";
import ResponsePopup from "../../../components/responsePopup";
import ToastNotification from "../../../components/ToastNotification";
import PlanningMetaDataEditForm from "../planningPerformanceNew/PlanningMetaDataEditForm";
import AssignNewTransmissionIdResponsePopup from "../planningPerformanceNew/AssignNewTransmissionIdResponsePopup";
import ProgramScheduleSlotEditForm from "../ProgramScheduleSlotEditForm";
import CreateRecursiveSlotPopup from "./CreateRecursiveSlotPopup";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";

//custom model field
const customModelFields = {
  id: "_id",
  title: "Title",
  description: "Description",
  start: "StartDate",
  end: "EndTime",
};
const group = {
  resources: ["Channels"],
};

const MyDays = [
  { Name: "Monday", ID: 1 },
  { Name: "Tuesday", ID: 2 },
  { Name: "Wednesday", ID: 3 },
  { Name: "Thursday", ID: 4 },
  { Name: "Friday", ID: 5 },
  { Name: "Saturday", ID: 6 },
  { Name: "Sunday", ID: 7 },
]

const MILLISECONDSINADAY = 86400000;

const Planning_prformance = (props, ref) => {

  const { filterChannels, date, isPrimeTime, onShowDeal, onShowMedia, onShowExhibitions, showCtrlADialog, showDeleteMenu, onShowLoopPopup, onCheckList, showCheckList, setStartType, onShowCopySlotPopup, onShowCopySchedulePopup, onShowRecursivePlan, setStatusMsg } = props;

  const allowCtrlAPopupRef = useRef(false);
  const SLOT_COLOR = '#CFD2CF';
  const SLOT_LOCK_COLOR = '#c8e3d4';
  let getWeekDate = utility.getWeekStartEndDates(date);
  const enableShortPlanningMenu = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.enableShortPlanningMenu) ?? false;
  const enablePlanningEditRightSideView = utility.getApplicationConfigurationByKey(ApplicationConfigurationKeys.enablePlanningEditRightSideView) ?? false;

  let preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);

  //NEW
  let offSetHours = isPrimeTime ? 0 : new Date(PlanningHelper.getDayStartTime(filterChannels) ?? 0).getUTCHours();

  const mainTimeZone = PlanningHelper.getMainTimeZone(filterChannels);

  //ALWAYS SUBTRACT OFFSET
  let offSetTime = (offSetHours * 3600000) - (mainTimeZone.IsNegativeOffset ? -mainTimeZone.Offset : mainTimeZone.Offset);

  const [customDates, setCustomDates] = useState({
    startDate: moment(date).format("YYYY-MM-DD"),
    endDate: moment(date).add(10, "days").format("YYYY-MM-DD"),
  });

  const getOffsetTime = () => {
    const preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);

    //NEW
    const offSetHours = isPrimeTime ? 0 : new Date(PlanningHelper.getDayStartTime(filterChannels) ?? 0).getUTCHours();

    //ALWAYS SUBTRACT OFFSET
    let offset = offSetHours * 3600000;

    const mainTimeZone = PlanningHelper.getMainTimeZone(filterChannels);
    offset = offset - (mainTimeZone.IsNegativeOffset ? -mainTimeZone.Offset : mainTimeZone.Offset);

    return offset;
  }

  const primeStartTime = isPrimeTime ? moment(preferenceData?.data[0]?.value?.TimeZone?.PrimeStartTime).utc().format('HH:mm') ?? "00:00" : "00:00";
  const primeEndTime = isPrimeTime ? moment(preferenceData?.data[0]?.value?.TimeZone?.PrimeEndTime).utc().format('HH:mm') ?? "23:59" : "23:59";

  const lang = useTranslation();
  const company = utility.getValue(LOCALSTORAGE_KEY.COMPANY);
  const isStarhub = company?.Name?.trim()?.toLowerCase() === "starhub";

  //time for slot duration in planner

  // const SLOT_TIMES = [5, 15, 30, 60, 120, 180]
  var selectedSlotDuration = utility.getSeassionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DURATION) ?? 60;
  var selectedSlotDivision = utility.getSeassionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DIVISION) ?? SLOT_DIVISIONS[SLOT_TIMES.indexOf(selectedSlotDuration)];
  // alert(selectedSlotDuration)
  const [slotDuration, setSlotDurationData] = useState(selectedSlotDuration);
  const [slotDivision, _setSlotDivision] = useState(selectedSlotDivision);
  const [txStatusData, setTxStatusData] = useState([])
  const [isPasteStrandWithCD, setIsPasteStrandWithCD] = useState(false);

  const setSlotDivision = (value) => {
    utility.setSessionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DIVISION, value);
    requestAnimationFrame(() => {
      startTransition(() => {
        _setSlotDivision(value);
      })
    })
  }

  const viewRef = useRef('week');
  const [view, setView] = useState('week');
  const isRightSide = enablePlanningEditRightSideView;

  const setViewData = (data) => {
    viewRef.current = data;
    setView(data);
  }

  const focusedPlanningItemPropRef = useRef({});
  const setFocusedPlanningItemPropRef = (data) => {
    focusedPlanningItemPropRef.current = data;
  };

  const defaultWeekStartData = Object.keys(Day).filter(key => key.length > 1).map(key => ({
    _id: Day[key],
    Description: key,
    bgColor: "white",
  }))[1];
  const [weekStartDay, setWeekStartDay] = useState(defaultWeekStartData);
  const weekStartDayRef = useRef(defaultWeekStartData);

  const setWeekStartDayData = (data) => {
    weekStartDayRef.current = data;
    setWeekStartDay(data);
  };

  const payloadRef = useRef({});

  const navigate = useNavigate();
  const slotDivisions = SLOT_DIVISIONS;

  //ALL THE POPUP STATES IN SINGLE STATES
  const defaultShowPopup = {
    fastSegmentation: false,
    updateSynopsis: false,
    insertDummyPopup: false,
    programReplacement: false,
    attachMediaToSlot: false,
    updateTXStatus: false,
    editDummyPopup: false,
    insertProgramGroup: false,
    updateComment: false,
    mediaDealRightPopup: false,
    showEditSlotDurationPopup: false,
    segmentationPopup: false,
    showCustomDatesPopup: false,
    showAmortizationPopup: false,
    showFormatSelection: false,
    addRouterCommand: false,
    showEditMetaDataPopup: false,
    showRightSideEditForm: false,
  }

  const enableSegmentSelectionPopup = true;

  const [showPopups, setShowPopups] = useState(defaultShowPopup);
  const [showPublishToVodResultPopup, setShowPublishToVodResultPopup] = useState(false)
  const [publishResults, setPublishResults] = useState([])

  const [assignNewTransmissionIdPopup, setAssignNewTransmissionIdPopup] = useState({show: false,selectedItems: [],updatedData: []});
  const [showCreateSlotPopup, setShowCreateSlotPopup] = useState(false);
  const [showCreateRecursiveSlotPopup, setShowCreateRecursiveSlotPopup] = useState(false);
  const [editingCustomSlot, setEditingCustomSlot] = useState(null);
  const [clickedCustomSlot, setClickedCustomSlot] = useState(null);
  const clickedCustomSlotRef = useRef(null);
  const [selectedSlotForAttach, setSelectedSlotForAttach] = useState(null);
  const selectedSlotForAttachRef = useRef(null);
  const [showDeleteRecursiveDialog, setShowDeleteRecursiveDialog] = useState(false);
  const [recursiveSlotToDelete, setRecursiveSlotToDelete] = useState(null);
  const [selectedDeleteRecursiveOption, setSelectedDeleteRecursiveOption] = useState("SELECTED");
  const [customSlots, setCustomSlots] = useState([]);
  const customSlotsRef = useRef([]);
  customSlotsRef.current = customSlots;

  const loadCustomSlotsData = async (channels, startDate, endDate) => {
    try {
      const channelSIDs = (channels || []).map((c) => (typeof c === "object" ? c.SID : c));
      const slots = await PlanningHelper.getCustomSlots(channelSIDs, startDate, endDate);
      setCustomSlots(slots || []);
      customSlotsRef.current = slots || [];
      return slots;
    } catch (e) {
      console.error("Error loading custom slots:", e);
      return [];
    }
  };

  const [customSlotDuration, setCustomSlotDuration] = useState("00:00:00:00");
  const [customSlotEndTime, setCustomSlotEndTime] = useState(null);

  const synopsisRef = useRef();
  const setSynopsisRef = (data) => {
    synopsisRef.current = data
  }

  const txStatusRef = useRef();
  const [txStatus, _setTxStatus] = useState({});
  const setTxStatus = (data) => {
    _setTxStatus(data);
    txStatusRef.current = data
  }

  const commentRef = useRef();
  const [comment, _setComment] = useState({});
  const setComment = (data) => {
    _setComment(data);
    commentRef.current = data
  }

  const routerCommandRef = useRef();
  const [routerCommand, _setRouterCommand] = useState({});
  const setRouterCommand = (data) => {
    _setRouterCommand(data);
    routerCommandRef.current = data
  }

  const programToReplaceRef = useRef({});
  const setProgramToReplace = (data) => {
    programToReplaceRef.current = data;
  };

  const slotDurationRef = useRef(selectedSlotDuration);
  const setSlotDuration = (duration) => {
    slotDurationRef.current = duration;
    setSlotDurationData(duration);
  };

  const isPlanningLoading = useRef(false);


  const plannerBlankAreaMenuModel = [
    {
      label: `${lang.paste_button_text}`,
      icon: "pi pi-fw pi-book",
      command: (e) => {
        onPaste();
      },
    },
    {
      label: `${'Paste Strand'}`,
      icon: "pi pi-fw pi-book",
      command: (e) => {
        onPasteStrand();
      },
    },
    {
      label: `${'Paste Strand With Custom Dur.'}`,
      icon: "pi pi-fw pi-book",
      command: (e) => {
        setShowPopups({ ...defaultShowPopup, showEditSlotDurationPopup: true })
        setIsPasteStrandWithCD(true);
      },
    },
    {
      label: `${lang.insert_program_group_label_planning}`,
      icon: "pi pi-fw pi-upload",
      command: (e) => {
        onInsertProgramGroup(true);
      },
    },
    {
      label: 'Lock / Unlock', icon: 'pi pi-fw pi-lock',
      command: async () => {
        let selectedChannel = filterChannels[selectedSlotRef.current.channelIndex];
        let channel = {
          _id: selectedChannel._id,
          name: selectedChannel.name
        }
        let date = selectedSlotRef.current.SlotDateTime.setUTCHours(0, 0, 0, 0);
        onLockUnlock(channel, date);

      }
    },

    // INSERT MOVIE DUMMY ( CHECK HERE FOR MULTIPLE )
    {
      label: `${lang.insert_dummy_label_planning}`,
      icon: "pi pi-fw pi-clone",
      command: (e) => {
        onInsertDummy(e);
      },
    },
    // CREATE CUSTOM SLOT
    {
      label: 'Create Slot',
      icon: 'pi pi-fw pi-plus-circle',
      visible: !(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        setEditingCustomSlot(null);
        setShowCreateSlotPopup(true);
      },
    },
    // ATTACH MEDIA TO CUSTOM SLOT
    {
      label: 'Attach Media',
      icon: 'pi pi-fw pi-paperclip',
      visible: !!(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        const slot = clickedCustomSlotRef.current || clickedCustomSlot;
        if (slot) {
          setSelectedSlotForAttach(slot);
          selectedSlotForAttachRef.current = slot;
          setShowPopups({ ...defaultShowPopup, attachMediaToSlot: true });
        }
      },
    },
    // EDIT SLOT
    {
      label: 'Edit Slot',
      icon: 'pi pi-fw pi-pencil',
      visible: !!(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        const slot = clickedCustomSlotRef.current || clickedCustomSlot;
        if (slot) {
          setEditingCustomSlot(slot);
          setShowCreateSlotPopup(true);
        }
      },
    },
    {
      label: 'Create Recursive Slot',
      icon: 'pi pi-fw pi-sync',
      command: () => {
        setShowCreateRecursiveSlotPopup(true);
      },
    },
    // DELETE CUSTOM SLOT
    {
      label: 'Delete Slot',
      icon: 'pi pi-fw pi-trash',
      visible: !!(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        const slot = clickedCustomSlotRef.current || clickedCustomSlot;
        if (slot) {
          deleteCustomSlotHandler(slot);
        }
      },
    },
  ];

  const deleteCustomSlotHandler = (slotToDelete) => {
    if (!slotToDelete) return;

    // If the slot is part of a recurring schedule, show the options dialog
    if (slotToDelete.recursiveId) {
      setRecursiveSlotToDelete(slotToDelete);
      setSelectedDeleteRecursiveOption("SELECTED");
      setShowDeleteRecursiveDialog(true);
      return;
    }

    // Normal non-recursive slot deletion
    ConfirmAlert(
      async () => {
        try {
          let res = null;
          if (slotToDelete.SID) {
            res = await API.deleteData(ENTITYNAME.ProgramScheduleSlot, slotToDelete.SID, 'SID');
          } else if (slotToDelete._id) {
            res = await API.deleteData(ENTITYNAME.ProgramScheduleSlot, slotToDelete._id, '_id');
          }
          if (res && res.success !== false) {
            ToastNotification({
              type: TOAST_TYPES.SUCCESS,
              title: "Slot Deleted",
              message: `Custom slot "${slotToDelete.Description || ""}" deleted successfully`
            });
            setClickedCustomSlot(null);
            clickedCustomSlotRef.current = null;
            refreshPlanning();
          } else {
            ToastNotification({
              type: TOAST_TYPES.ERROR,
              title: "Error",
              message: res?.message || "Failed to delete custom slot"
            });
          }
        } catch (err) {
          console.error("Error deleting custom slot:", err);
          ToastNotification({
            type: TOAST_TYPES.ERROR,
            title: "Error",
            message: err.message || "Failed to delete custom slot"
          });
        }
      },
      () => {},
      "Delete Custom Slot",
      `Are you sure you want to delete custom slot "${slotToDelete.Description || ""}"?`
    );
  };

  const onConfirmDeleteRecursiveSlot = async () => {
    if (!recursiveSlotToDelete) return;
    const slot = recursiveSlotToDelete;
    setShowDeleteRecursiveDialog(false);

    try {
      let res = null;
      if (selectedDeleteRecursiveOption === "SELECTED") {
        if (slot.SID) {
          res = await API.deleteData(ENTITYNAME.ProgramScheduleSlot, slot.SID, 'SID');
        } else if (slot._id) {
          res = await API.deleteData(ENTITYNAME.ProgramScheduleSlot, slot._id, '_id');
        }
      } else if (selectedDeleteRecursiveOption === "ALL") {
        res = await API.deleteProgramScheduleSlotRecursive({
          recursiveId: slot.recursiveId,
          deleteOption: "ALL"
        });
      } else if (selectedDeleteRecursiveOption === "FORWARD") {
        const slotTime = typeof slot.SlotStart === 'number' ? slot.SlotStart : slot.SlotDateTime;
        res = await API.deleteProgramScheduleSlotRecursive({
          recursiveId: slot.recursiveId,
          deleteOption: "FORWARD",
          fromSlotDateTime: slotTime
        });
      }

      if (res && res.success !== false) {
        ToastNotification({
          type: TOAST_TYPES.SUCCESS,
          title: "Slots Deleted",
          message: res.message || "Custom slot(s) deleted successfully"
        });
        setClickedCustomSlot(null);
        clickedCustomSlotRef.current = null;
        setRecursiveSlotToDelete(null);
        refreshPlanning();
      } else {
        ToastNotification({
          type: TOAST_TYPES.ERROR,
          title: "Error",
          message: res?.message || "Failed to delete slot(s)"
        });
      }
    } catch (err) {
      console.error("Error deleting recursive slot:", err);
      ToastNotification({
        type: TOAST_TYPES.ERROR,
        title: "Error",
        message: err.message || "Failed to delete slot(s)"
      });
    }
  };

  const onLockUnlock = async (channel, date) => {

    let isLocked = lockedPlaylistRef.current.some(data => data.channel._id == channel._id && data.date == date);

    await utility.lockUnlockPlaylist(channel, date, MODULE.PLANNING, !isLocked);

    let channelSID = filterChannels.filter(data => data._id == channel._id)[0].SID;
    let userData = utility.getValue(LOCALSTORAGE_KEY.userData);
    socket?.emit(SOCKET_EVENTS.onSocketData, {
      action: SOCKET_ACTION.SCHEDULE_LOCK_UPDATE,
      module: MODULE.SCHEDULING,
      data: {
        selectedChannelSID: channelSID, selectedScheduleDate: date
      },
      user: { name: userData.name, _id: userData._id }
    });
    socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_REFRESH, module: MODULE.PLANNING, data: { scheduleScheduleStartDate: date, scheduleScheduleEndDate: date, channelSID: channelSID } });

    let logData = { event: isLocked ? LOGEVENT.UNLOCK_PLANNING : LOGEVENT.LOCK_PLANNING, module: MODULE.PLANNING, data: userData, message: isLocked ? LOGEVENT.UNLOCK_PLANNING : LOGEVENT.LOCK_PLANNING };
    API.SaveLogs(logData);
    refreshPlanning();
  }

  const onLockUnlockItem = async (planningItem) => {
    let isPlanningItemLocked = planningItem?.isLocked ?? false;

    let res = await API.canLockUnlockItem(planningItem._id, !isPlanningItemLocked);
    let currHeaderIndex = displayData.sort((a, b) => a.SlotDateTime - b.SlotDateTime).findIndex(data => data._id == planningItem._id);

    let nextHeaderStartTime = (currHeaderIndex + 1) < displayData.length ? displayData[currHeaderIndex + 1].SlotDateTime : null;

    if (res.success) {
      if (isPlanningItemLocked) {
        const result = await API.unlockItem(planningItem, res.data);
        if (result.success) {
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Planning item unlocked successfully` });
          let logData = { event: LOGEVENT.UNLOCK_PLANNING_ITEM, module: MODULE.PLANNING, data: { headerStartTime: planningItem.SlotDateTime, nextHeaderStartTime: nextHeaderStartTime, header: planningItem, segments: res.data }, message: LOGEVENT.UNLOCK_PLANNING_ITEM };
          API.SaveLogs(logData);
          setDisplayData(old => old.map(data => data._id == planningItem._id ? { ...data, isLocked: !isPlanningItemLocked } : data));
        } else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: result.message });
        }
        return;
      } else {
        // if can lock then show popup
        setHeaderLockPopup({
          show: true,
          segments: res.data,
          header: planningItem,
          nextHeaderStartTime: nextHeaderStartTime
        });
        console.log(res.data);
      }
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onApplyFormatClick = async (list) => {

    console.log("IN APPLY FORMAT");

    const selectedHeader = {
      current: focusedPlanningItemPropRef.current.dataItem
    }

    console.log(selectedHeader);

    if (selectedHeader.current == undefined || selectedHeader.current.mediaEpisode._id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Header not selected.' });
      return;
    }

    if (
      selectedHeader.current.children != undefined &&
      selectedHeader.current.children.length > 0 &&
      selectedHeader.current.children.some((x) => x.IsFromFormat)
    ) {

      ConfirmAlert(
        async () => {
          await onApplyFormat(list, true)
        }, // on Click yes
        async () => {
          await onApplyFormat(list)
        }, // on click no
        "Format already applied on this header.", //title
        "While applying new format, do you want to delete existing short forms of the old format ?" // message
      );

    } else {
      await onApplyFormat(list);
    }

  };

  const onApplyFormat = async (list) => {

    const selectedFormat = list[0];
    let userData = utility.getValue(LOCALSTORAGE_KEY.userData);

    const selectedHeader = {
      current: focusedPlanningItemPropRef.current.dataItem
    }

    // attaching format
    var media = {
      _id: selectedHeader.current.mediaEpisode._id,
      SID: selectedHeader.current.mediaEpisode.SID,
      AssetId: selectedHeader.current.mediaEpisode.AssetId,
      Duration: selectedHeader.current.mediaEpisode.Duration
    };

    var payload = {
      media: [media],
      formats: [selectedFormat]
    }

    await API.attachFormats(payload);

    // get valid segment for same count as of selected format.
    var validSegment = await SchedulingHelper.getMediaEpisodeValidSegment(selectedFormat, selectedHeader.current.mediaEpisode);

    if (validSegment == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Valid segment not found after attaching format" });
      return;
    }

    const saveData = {
      SID: 0,
      Channel: filterChannels[selectedSlotRef.current.channelIndex],
      MediaEpisode_id: selectedHeader.current.mediaEpisode._id,
      ScheduleDate: selectedHeader.current.SlotDateTime,
      SlotDateTime: selectedHeader.current.SlotDateTime,
      TXStatus: selectedHeader.current.TXStatus,
      Segment_id: validSegment._id.toString(),
      ParentProgramSchedule_id: null,
      IsValid: true,
      MediaDealRight_id: selectedHeader.current.MediaDealRight_id,
      Format_id: selectedFormat._id,
    };

    let deleteChildren = false;

    //DELETING CHILDREN FOR ROTANA
    if (company && company.Name && company.Name.toLowerCase() == "rotana") {
      deleteChildren = true;
    }

    var response = await API.ReplaceProgram(saveData, selectedHeader.current, deleteChildren);
    console.log(response);

    if (response.success) {

      refreshPlanning();

      let logData = { event: LOGEVENT.ATTACH_FORMAT_FROM_PLANNING, module: MODULE.PLANNING, data: userData, message: LOGEVENT.ATTACH_FORMAT_FROM_PLANNING };
      API.SaveLogs(logData);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Format Attached !!" });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }

  };

  const refreshSchedule = (channel, date) => {

    let channelSID = channel.SID && channel.SID > 0 ? channel.SID : filterChannels.filter(data => data._id == channel._id)[0]?.SID ?? 0;

    if (channelSID == 0) return;

    let userData = utility.getValue(LOCALSTORAGE_KEY.userData);
    socket?.emit(SOCKET_EVENTS.onSocketData, {
      action: SOCKET_ACTION.SCHEDULE_REFRESH,
      module: MODULE.SCHEDULING,
      data: {
        selectedChannelSID: channelSID, selectedScheduleDate: date
      },
      user: { name: userData.name, _id: userData._id }
    });
  }

  const plannerSelectedItemsRef = useRef([]);
  const selectedPlannerItemIdsRef = useRef([]);
  const getPlanningItemDomId = (itemId) => `planning-item-${itemId}`;

  const clearSelectedPlannerItemStyles = () => {
    selectedPlannerItemIdsRef.current.forEach((id) => {
      const selector = `[id="${getPlanningItemDomId(id)}"]`;
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {
        element.style.border = "";
        element.style.boxShadow = "";
      });
    });
    selectedPlannerItemIdsRef.current = [];
  };

  const applySelectedStyle = (element) => {
    if (!element) return;
    element.style.border = "2px solid #212529";
    element.style.boxShadow = "0 2px 8px rgba(0,0,0,0.15)";
  };

  const updateSelectedCountElement = (count) => {
    const selectedCountElement = document.getElementById("planning-selected-count");
    if (selectedCountElement) {
      selectedCountElement.textContent = `${count} ${lang.selected_label}`;
    }
  };

  const styleSelectedPlannerItems = (dataItems, activeTarget = null) => {
    clearSelectedPlannerItemStyles();
    const ids = dataItems.map((item) => item._id);

    const activeTargetId = activeTarget?.id?.replace?.("planning-item-", "");
    if (activeTargetId && ids.includes(activeTargetId)) {
      applySelectedStyle(activeTarget);
    }

    ids.forEach((id) => {
      const selector = `[id="${getPlanningItemDomId(id)}"]`;
      const elements = document.querySelectorAll(selector);
      elements.forEach((element) => {
        applySelectedStyle(element);
      });
    });

    selectedPlannerItemIdsRef.current = ids;
  };

  const setPlannerSelectedItems = (data, activeTarget = null) => {
    plannerSelectedItemsRef.current = data;
    styleSelectedPlannerItems(data, activeTarget);
    updateSelectedCountElement(data.length);
    if (props.onSelectedPlanningItem) {
      props.onSelectedPlanningItem(data);
    }
  };

  const selectPlanningItemFromDomEvent = (event) => {
    const itemElement = event.target?.closest?.("[id^='planning-item-']");
    if (!itemElement) {
      return;
    }

    const itemId = itemElement.id.replace("planning-item-", "");
    const dataItem = dataRef.current.find((item) => item._id == itemId);
    if (!dataItem) {
      return;
    }

    if (event.button === 2 || event.which === 3) {
      if (!plannerSelectedItemsRef.current.some((item) => item._id == dataItem._id)) {
        setPlannerSelectedItems([dataItem], itemElement);
      } else {
        styleSelectedPlannerItems(plannerSelectedItemsRef.current, itemElement);
      }
      return;
    }
  };

  const plannerOnItemMenuModel = [
    {
      label: `${lang.open_schedule_button_text_planning}`,
      icon: "fa fa-upload ml-1 pr-1 p-menuitem-icon",
      command: () => {

        if (!utility.hasModuleRights(MODULE.SCHEDULING)) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_rights_scheduling_error_message });
          return;
        }
        if (focusedPlanningItemPropRef.current) {

          let offST = PlanningHelper.getOffSetTimeWithTimeZone(focusedPlanningItemPropRef.current.dataItem.Channel, isPrimeTime);

          // utility.setValue(LOCALSTORAGE_KEY.publishData, { ...focusedPlanningItemPropRef.current.dataItem, start_time: focusedPlanningItemPropRef.current.start_time ?? '00:00' });
          // utility.setSessionValue(
          //   LOCALSTORAGE_KEY.publishData,
          //   focusedPlanningItemPropRef.current.dataItem
          // );

          utility.setSessionValue(
            LOCALSTORAGE_KEY.publishData,
            { ...focusedPlanningItemPropRef.current.dataItem, SlotDateTime: focusedPlanningItemPropRef.current.dataItem.SlotDateTime - offST }
          );
          navigate("/home/Scheduling");
        } else {
          console.log("not selected item");
          alert("Pleaseselect planning item");
        }
      },
    },
    {
      label: `${lang.edit_actionbutton_option}`,
      icon: "pi pi-fw pi-plus",
      command: () => {
        setShowPopups({ ...defaultShowPopup, showRightSideEditForm: true });
      },
    },
    {
      label: `${lang.delete_actionbutton_option}`,
      icon: "pi pi-fw pi-trash",
      command: () => {
        showDeleteMenu();
      },
    },
    {
      label: `${lang.cut_label}`,
      icon: "pi pi-fw pi-times",
      command: () => {
        if (plannerSelectedItemsRef.current.length == 0) {
          setPlannerSelectedItems([
            focusedPlanningItemPropRef.current.dataItem,
          ]);
        }

        onCut();
      },
    },
    {
      label: `${lang.copy_button_text}`,
      icon: "pi pi-fw pi-copy",
      command: () => {
        if (plannerSelectedItemsRef.current.length == 0) {
          setPlannerSelectedItems([
            focusedPlanningItemPropRef.current.dataItem,
          ]);
        }

        onCopy();
      },
    },
    {
      label: lang.show_menu_label,
      icon: "pi pi-fw pi-eye",
      items: [
        {
          label: lang.media_menu_label,
          icon: "pi pi-fw pi-eject",
          command: () => {
            onShowMedia(focusedPlanningItemPropRef.current.dataItem.mediaEpisode);
          }
        },
        {
          label: lang.deal_menu_label,
          icon: "pi pi-fw pi-briefcase",
          command: () => {
            onShowDeal(focusedPlanningItemPropRef.current.dataItem);
          }
        },
        {
          label: lang.history_button_text_planning,
          icon: "pi pi-fw pi-history",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectShowHistory();
          },
        },
        {
          label: "Recursive plan",
          icon: "pi pi-fw pi-bars",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            onShowRecursivePlan();
          },
        },
        {
          label: lang.exhibitions_menu_label,
          icon: "pi pi-fw pi-book",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            onShowExhibitions();
          }
        },
        {
          label: lang.logs_menu_label,
          icon: "pi pi-fw pi-external-link",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            let path = '/home/AuditLog' + "?module=" + MODULE.PLANNING + "&Header_id=" + focusedPlanningItemPropRef.current.dataItem?._id + "&title=" + focusedPlanningItemPropRef.current.dataItem?.mediaEpisode?.Title
            window.open(path, "_blank");
          }
        },
      ]
    },
    {
      label: `${lang.run_button_text_planning}`,
      icon: "pi pi-fw pi-bars",
      items: [
        {
          label: `${lang.apply_recursive_button_text_planning}`,
          icon: "pi pi-fw pi-bars",

          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectApplyRecursive();
            // setPlannerSelectedItems([]);
          },
        },
        {
          label: `Copy Slots`,
          icon: "pi pi-fw pi-clone",
          //new copy slot menu
          command: () => {
            onShowCopySlotPopup();
          },
        },
        {
          label: `Copy/Move Schedule`,
          icon: "pi pi-fw pi-copy",
          //new copy slot menu
          command: () => {
            onShowCopySchedulePopup();
          },
        },
        {
          label: `${lang.apply_distribution_button_text_planning}`,
          icon: "pi pi-fw pi-sliders-h",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectDistributePlanningAcrossChannels();
          },
        },
        {
          label: `Loop`,
          icon: "pi pi-fw pi-circle",
          command: () => {
            onShowLoopPopup(focusedPlanningItemPropRef.current.dataItem);
          },
        }
      ]
    },
    {
      label: "Lock / Unlock",
      icon: "pi pi-fw pi-lock",
      items: [
        {
          label: lang.lock_unlock_label,
          icon: "pi pi-fw pi-lock",
          command: () => {
            let selectedChannel = focusedPlanningItemPropRef.current.dataItem.Channel;
            let channel = {
              _id: selectedChannel._id,
              name: selectedChannel.name
            }
            let date = focusedPlanningItemPropRef.current.start.setUTCHours(0, 0, 0, 0);
            onLockUnlock(channel, date);
          },
        },
        {
          label: lang.lock_unlock_label + ' Item',
          icon: "pi pi-fw pi-lock",
          command: () => {
            onLockUnlockItem(focusedPlanningItemPropRef.current.dataItem);
          },
        }

      ]
    },
    //update synopsis
    {
      label: `${lang.update_synopsis}`,
      icon: "pi pi-fw pi-align-center",
      command: () => {
        setSynopsisRef(focusedPlanningItemPropRef.current.dataItem.SlotSynopsis ?? '');
        setShowPopups({ ...defaultShowPopup, updateSynopsis: true })
      },
    },
    //Update Tx Status
    {
      label: `${lang.update_txstatus_actionbutton_menutext}`,
      icon: "fa fa-lg fa-solid fa-satellite-dish",
      command: () => {
        let item = plannerSelectedItemsRef.current.length > 1 ? plannerSelectedItemsRef.current[0] : focusedPlanningItemPropRef.current?.dataItem;
        setTxStatus(item.TXStatus);
        setShowPopups({ ...defaultShowPopup, updateTXStatus: true })
      }
    },
    //Update Comments
    {
      label: `${lang.add_comment_actionbutton_menutext}`,
      icon: "pi pi-fw pi-comment",
      command: () => {
        setComment(focusedPlanningItemPropRef.current?.dataItem?.Comment ?? '');
        setShowPopups({ ...defaultShowPopup, updateComment: true })
      }
    },
    // Remove Start and End Credits
    {
      label: lang.delete_start_end_credits_label,
      icon: "pi pi-fw pi-trash",
      items: [
        // Start Credits
        {
          label: `${lang.delete_start_credits_label}`,
          icon: "pi pi-fw pi-step-forward",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.StartCredit)
          },
        },
        //End Credits
        {
          label: `${lang.delete_end_credits_label}`,
          icon: "pi pi-fw pi-step-backward",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.EndCredit)
          },
        },
        //Both Credits
        {
          label: `${lang.delete_both_credits_label}`,
          icon: "pi pi-fw pi-arrows-h",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.Both)
          },
        },
      ]
    },
    // Add Catch Up
    {
      label: focusedPlanningItemPropRef.current?.dataItem?.IsCatchUp ? lang.un_marked_as_catch_up_actionbutton_menutext : lang.mark_as_catch_up_actionbutton_menutext,
      icon: "pi pi-fw pi-clock",
      command: () => {
        onMarkAsCatchUp(focusedPlanningItemPropRef.current?.dataItem?.IsCatchUp ? false : true);
      }
    },
    // Publish Changes To L2V
    {
      label: lang.publish_to_vod_actionbutton_menutext,
      icon: "pi pi-fw pi-upload",
      command: () => {
        onUpdateL2VEvent();
      }
    },
    {
      label: lang.assign_new_transmissionid_actionbutton_menutext,
      icon: "pi pi-fw pi-refresh",
      command: () => {
        onAssignNewTransmissionID();
      }
    },
    // Black Out
    {
      label: focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? lang.un_mark_as_black_out_actionbutton_menutext : lang.mark_as_black_out_actionbutton_menutext,
      icon: `pi pi-fw pi-${focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? 'ban' : 'circle'}`,
      command: () => {
        onMarkAsBlackOut(focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? false : true);
      }
    },
    //Add Router Command
    {
      label: lang.add_router_command,
      icon: "fa-solid fa-lg fa-diamond-turn-right",
      command: () => {
        //VALIDATION FOR LIVE & SDD ONLY
        if (
          focusedPlanningItemPropRef.current?.dataItem?.TXStatus?.SID != TX_STATUS.Live &&
          focusedPlanningItemPropRef.current?.dataItem?.TXStatus?.SID != TX_STATUS.SDD
        ) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.router_command_can_only_be_added_for_live_and_sdd });
          return;
        }

        setRouterCommand(focusedPlanningItemPropRef.current?.dataItem?.RouterCommand ?? '');
        setShowPopups({ ...defaultShowPopup, addRouterCommand: true })
      }
    },
    // Important
    {
      label: focusedPlanningItemPropRef?.current?.dataItem?.isImportant ? lang.remove_as_important : lang.set_as_important,
      icon: "fa fa-lg fa-exclamation-triangle",
      command: () => {
        handleSetImportant(focusedPlanningItemPropRef?.current?.dataItem?.isImportant ? false : true);
      }
    },
    // update custom duartion
    {
      label: `Set Custom Duration`,
      icon: "pi pi-fw pi-pencil",
      command: () => {
        setCustomSlotDuration(utility.convertMilisecondsToStringWithFrames(plannerSelectedItemsRef.current[0]?.customDuration ?? plannerSelectedItemsRef.current[0]?.mediaEpisode?.Duration ?? 0));
        setCustomSlotEndTimePickerDate();
        setShowPopups({ ...defaultShowPopup, showEditSlotDurationPopup: true })
      }
    },
    {
      label: `Clear Custom Duration`,
      icon: "pi pi-fw pi-calendar-times",
      command: () => {
        onClearCustomDuration();
      }
    },
    ...(isStarhub ? [{
      label: `Edit Slot Meta Data`,
      icon: "pi pi-fw pi-pencil",
      command: () => {
        setShowPopups({ ...defaultShowPopup, showEditMetaDataPopup: true })
      }
    }] : []),

    //ATTACH FORMAT
    {
      label: `${lang.attach_format_reload_actionbutton_menutext}`,
      icon: "pi pi-fw pi-microsoft",
      command: () => { setShowPopups({ ...defaultShowPopup, showFormatSelection: true }) }
    },

    //FAST SEGMENTATION
    {
      label: `${lang.fast_segmentation_actionbutton_menutext}`,
      icon: 'pi pi-fw pi-bolt',
      command: () => { setShowPopups({ ...defaultShowPopup, fastSegmentation: true }) }
    },
    //REPLACE
    {
      label: `${lang.replace_actionbutton_menutext}`,
      icon: "pi pi-fw pi-sync",
      command: () => { setShowPopups({ ...defaultShowPopup, programReplacement: true }) }
    },
    //ATTACH MEDIA TO CUSTOM SLOT
    {
      label: 'Attach Media to Slot',
      icon: 'pi pi-fw pi-paperclip',
      visible: !!(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        const slot = clickedCustomSlotRef.current || clickedCustomSlot;
        if (slot) {
          setSelectedSlotForAttach(slot);
          selectedSlotForAttachRef.current = slot;
          setShowPopups({ ...defaultShowPopup, attachMediaToSlot: true });
        }
      },
    },

    //EDIT DUMMY 
    {
      label: `${lang.edit_dummy_actionbutton_menutext}`,
      icon: "fa-solid fa-lg fa-pen-to-square",
      command: () => { onEditDummy() }
    },
    {
      label: `Mark as Changed `,
      icon: "pi pi-sync",
      items: [
        //Mark Change Flag
        {
          label: `Mark as Changed `,
          icon: "pi pi-sync",
          command: () => {
            onMarkChangeFlag(true);
          }
        },
        //Clear Change Flag
        {
          label: `Mark as Not Changed `,
          icon: "pi pi-undo",
          command: () => {
            onMarkChangeFlag(false);
          }
        }
      ]
    },

    //Amortisation Value Report
    {
      label: lang.amortisation_value_report,
      icon: "fa-solid fa-lg fa-money-bill",
      command: () => {
        setShowPopups({ ...defaultShowPopup, showAmortizationPopup: true })
      }
    },
  ];

  const plannerOnItemMenuModelShort = [
    {
      label: `${lang.open_schedule_button_text_planning}`,
      icon: "fa fa-upload ml-1 pr-1 p-menuitem-icon",
      command: () => {

        if (!utility.hasModuleRights(MODULE.SCHEDULING)) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.no_rights_scheduling_error_message });
          return;
        }
        if (focusedPlanningItemPropRef.current) {

          let offST = PlanningHelper.getOffSetTimeWithTimeZone(focusedPlanningItemPropRef.current.dataItem.Channel, isPrimeTime);

          // utility.setValue(LOCALSTORAGE_KEY.publishData, { ...focusedPlanningItemPropRef.current.dataItem, start_time: focusedPlanningItemPropRef.current.start_time ?? '00:00' });
          // utility.setSessionValue(
          //   LOCALSTORAGE_KEY.publishData,
          //   focusedPlanningItemPropRef.current.dataItem
          // );

          utility.setSessionValue(
            LOCALSTORAGE_KEY.publishData,
            { ...focusedPlanningItemPropRef.current.dataItem, SlotDateTime: focusedPlanningItemPropRef.current.dataItem.SlotDateTime - offST }
          );
          navigate("/home/Scheduling");
        } else {
          console.log("not selected item");
          alert("Pleaseselect planning item");
        }
      },
    },
    {
      label: `${lang.edit_actionbutton_option}`,
      icon: "pi pi-fw pi-plus",
      command: () => {
        setShowPopups({ ...defaultShowPopup, showRightSideEditForm: true });
      },
    },
    {
      label: `${lang.delete_actionbutton_option}`,
      icon: "pi pi-fw pi-trash",
      command: () => {
        showDeleteMenu();
      },
    },
    {
      label: `${lang.cut_label}`,
      icon: "pi pi-fw pi-times",
      command: () => {
        if (plannerSelectedItemsRef.current.length == 0) {
          setPlannerSelectedItems([
            focusedPlanningItemPropRef.current.dataItem,
          ]);
        }

        onCut();
      },
    },
    {
      label: `${lang.copy_button_text}`,
      icon: "pi pi-fw pi-copy",
      command: () => {
        if (plannerSelectedItemsRef.current.length == 0) {
          setPlannerSelectedItems([
            focusedPlanningItemPropRef.current.dataItem,
          ]);
        }

        onCopy();
      },
    },
    //REPLACE
    {
      label: `${lang.replace_actionbutton_menutext}`,
      icon: "pi pi-fw pi-sync",
      command: () => { setShowPopups({ ...defaultShowPopup, programReplacement: true }) }
    },
    //ATTACH MEDIA TO CUSTOM SLOT
    {
      label: 'Attach Media to Slot',
      icon: 'pi pi-fw pi-paperclip',
      visible: !!(clickedCustomSlotRef.current || clickedCustomSlot),
      command: () => {
        const slot = clickedCustomSlotRef.current || clickedCustomSlot;
        if (slot) {
          setSelectedSlotForAttach(slot);
          selectedSlotForAttachRef.current = slot;
          setShowPopups({ ...defaultShowPopup, attachMediaToSlot: true });
        }
      },
    },
    {
      label: lang.show_menu_label,
      icon: "pi pi-fw pi-eye",
      items: [
        {
          label: lang.media_menu_label,
          icon: "pi pi-fw pi-eject",
          command: () => {
            onShowMedia(focusedPlanningItemPropRef.current.dataItem.mediaEpisode);
          }
        },
        {
          label: lang.deal_menu_label,
          icon: "pi pi-fw pi-briefcase",
          command: () => {
            onShowDeal(focusedPlanningItemPropRef.current.dataItem);
          }
        },
        {
          label: lang.history_button_text_planning,
          icon: "pi pi-fw pi-history",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectShowHistory();
          },
        },
        {
          label: "Recursive plan",
          icon: "pi pi-fw pi-bars",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            onShowRecursivePlan();
          },
        },
        {
          label: lang.exhibitions_menu_label,
          icon: "pi pi-fw pi-book",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            onShowExhibitions();
          }
        },
        {
          label: lang.logs_menu_label,
          icon: "pi pi-fw pi-external-link",
          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            let path = '/home/AuditLog' + "?module=" + MODULE.PLANNING + "&Header_id=" + focusedPlanningItemPropRef.current.dataItem?._id + "&title=" + focusedPlanningItemPropRef.current.dataItem?.mediaEpisode?.Title
            window.open(path, "_blank");
          }
        },
      ]
    },
    {
      label: `${lang.run_button_text_planning}`,
      icon: "pi pi-fw pi-bars",
      items: [
        {
          label: `${lang.apply_recursive_button_text_planning}`,
          icon: "pi pi-fw pi-bars",

          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectApplyRecursive();
            // setPlannerSelectedItems([]);
          },
        },
        {
          label: `Copy Slots`,
          icon: "pi pi-fw pi-clone",
          //new copy slot menu
          command: () => {
            onShowCopySlotPopup();
          },
        },
        {
          label: `Copy/Move Schedule`,
          icon: "pi pi-fw pi-copy",
          //new copy slot menu
          command: () => {
            onShowCopySchedulePopup();
          },
        },
        {
          label: `${lang.apply_distribution_button_text_planning}`,
          icon: "pi pi-fw pi-sliders-h",

          command: () => {
            setPlannerSelectedItems([focusedPlanningItemPropRef.current.dataItem]);
            props.onSelectDistributePlanningAcrossChannels();
          },
        },
        {
          label: `Loop`,
          icon: "pi pi-fw pi-circle",

          command: () => {
            onShowLoopPopup(focusedPlanningItemPropRef.current.dataItem);
          },
        }
      ]
    },
    {
      label: "Lock / Unlock",
      icon: "pi pi-fw pi-lock",
      items: [
        {
          label: lang.lock_unlock_label,
          icon: "pi pi-fw pi-lock",
          command: () => {
            let selectedChannel = focusedPlanningItemPropRef.current.dataItem.Channel;
            let channel = {
              _id: selectedChannel._id,
              name: selectedChannel.name
            }
            let date = focusedPlanningItemPropRef.current.start.setUTCHours(0, 0, 0, 0);
            onLockUnlock(channel, date);
          },
        },
        {
          label: lang.lock_unlock_label + ' Item',
          icon: "pi pi-fw pi-lock",
          command: () => {
            onLockUnlockItem(focusedPlanningItemPropRef.current.dataItem);
          },
        }

      ]
    },
    {
      label: lang.update_properties_button_text_planning,
      icon: "pi pi-fw pi-cog",
      items: [
        //update synopsis
        {
          label: `${lang.update_synopsis}`,
          icon: "pi pi-fw pi-align-center",
          command: () => {
            setSynopsisRef(focusedPlanningItemPropRef.current.dataItem.SlotSynopsis ?? '');
            setShowPopups({ ...defaultShowPopup, updateSynopsis: true })
          },
        },
        //Update Tx Status
        {
          label: `${lang.update_txstatus_actionbutton_menutext}`,
          icon: "fa fa-lg fa-solid fa-satellite-dish",
          command: () => {
            let item = plannerSelectedItemsRef.current.length > 1 ? plannerSelectedItemsRef.current[0] : focusedPlanningItemPropRef.current?.dataItem;
            setTxStatus(item.TXStatus);
            setShowPopups({ ...defaultShowPopup, updateTXStatus: true })
          }
        },
        //Update Comments
        {
          label: `${lang.add_comment_actionbutton_menutext}`,
          icon: "pi pi-fw pi-comment",
          command: () => {
            setComment(focusedPlanningItemPropRef.current?.dataItem?.Comment ?? '');
            setShowPopups({ ...defaultShowPopup, updateComment: true })
          }
        },
        //Add Router Command
        {
          label: lang.add_router_command,
          icon: "fa-solid fa-lg fa-diamond-turn-right",
          command: () => {
            //VALIDATION FOR LIVE & SDD ONLY
            if (
              focusedPlanningItemPropRef.current?.dataItem?.TXStatus?.SID != TX_STATUS.Live &&
              focusedPlanningItemPropRef.current?.dataItem?.TXStatus?.SID != TX_STATUS.SDD
            ) {
              ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.router_command_can_only_be_added_for_live_and_sdd });
              return;
            }

            setRouterCommand(focusedPlanningItemPropRef.current?.dataItem?.RouterCommand ?? '');
            setShowPopups({ ...defaultShowPopup, addRouterCommand: true })
          }
        },
        // Important
        {
          label: focusedPlanningItemPropRef?.current?.dataItem?.isImportant ? lang.remove_as_important : lang.set_as_important,
          icon: "fa fa-lg fa-exclamation-triangle",
          command: () => {
            handleSetImportant(focusedPlanningItemPropRef?.current?.dataItem?.isImportant ? false : true);
          }
        },
        // update custom duartion
        {
          label: `Set Custom Duration`,
          icon: "pi pi-fw pi-pencil",
          command: () => {
            setCustomSlotDuration(utility.convertMilisecondsToStringWithFrames(plannerSelectedItemsRef.current[0]?.customDuration ?? plannerSelectedItemsRef.current[0]?.mediaEpisode?.Duration ?? 0));
            setCustomSlotEndTimePickerDate();
            setShowPopups({ ...defaultShowPopup, showEditSlotDurationPopup: true })
          }
        },
        {
          label: `Clear Custom Duration`,
          icon: "pi pi-fw pi-calendar-times",
          command: () => {
            onClearCustomDuration();
          }
        },
        ...(isStarhub ? [{
          label: `Edit Slot Meta Data`,
          icon: "pi pi-fw pi-pencil",
          command: () => {
            setShowPopups({ ...defaultShowPopup, showEditMetaDataPopup: true })
          }
        }] : []),
        {
          label: lang.assign_new_transmissionid_actionbutton_menutext,
          icon: "pi pi-fw pi-refresh",
          command: () => {
            onAssignNewTransmissionID();
          }
        },
      ]
    },
    // Remove Start and End Credits
    {
      label: lang.delete_start_end_credits_label,
      icon: "pi pi-fw pi-trash",
      items: [
        // Start Credits
        {
          label: `${lang.delete_start_credits_label}`,
          icon: "pi pi-fw pi-step-forward",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.StartCredit)
          },
        },
        //End Credits
        {
          label: `${lang.delete_end_credits_label}`,
          icon: "pi pi-fw pi-step-backward",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.EndCredit)
          },
        },
        //Both Credits
        {
          label: `${lang.delete_both_credits_label}`,
          icon: "pi pi-fw pi-arrows-h",
          command: (e) => {
            onRemoveStartAndEndCredits(SEGMENT_DETAILS_CREDIT_TYPE.Both)
          },
        },
      ]
    },
    // Publish Changes To L2V
    {
      label: lang.publish_to_vod_actionbutton_menutext,
      icon: "pi pi-fw pi-upload",
      command: () => {
        onUpdateL2VEvent();
      }
    },
    //ATTACH FORMAT
    {
      label: `${lang.attach_format_reload_actionbutton_menutext}`,
      icon: "pi pi-fw pi-microsoft",
      command: () => { setShowPopups({ ...defaultShowPopup, showFormatSelection: true }) }
    },

    //FAST SEGMENTATION
    {
      label: `${lang.fast_segmentation_actionbutton_menutext}`,
      icon: 'pi pi-fw pi-bolt',
      command: () => { setShowPopups({ ...defaultShowPopup, fastSegmentation: true }) }
    },
    //EDIT DUMMY 
    {
      label: `${lang.edit_dummy_actionbutton_menutext}`,
      icon: "fa-solid fa-lg fa-pen-to-square",
      command: () => { onEditDummy() }
    },
    {
      label: `${lang.mark_label}`,
      icon: "pi pi-sync",
      items: [
        //Mark Change Flag
        {
          label: `${lang.changed_label}`,
          icon: "pi pi-sync",
          command: () => {
            onMarkChangeFlag(true);
          }
        },
        //Clear Change Flag
        {
          label: `${lang.not_changed_label}`,
          icon: "pi pi-undo",
          command: () => {
            onMarkChangeFlag(false);
          }
        },
        {
          label: focusedPlanningItemPropRef.current?.dataItem?.IsCatchUp ? lang.un_marked_as_catch_up_actionbutton_menutext : lang.mark_as_catch_up_actionbutton_menutext,
          icon: "pi pi-fw pi-check-square",
          command: () => {
            onMarkAsCatchUp(focusedPlanningItemPropRef.current?.dataItem?.IsCatchUp ? false : true);
          }
        },
        {
          label: focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? lang.un_mark_as_black_out_actionbutton_menutext : lang.mark_as_black_out_actionbutton_menutext,
          icon: `pi pi-fw pi-${focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? 'ban' : 'circle'}`,
          command: () => {
            onMarkAsBlackOut(focusedPlanningItemPropRef.current?.dataItem?.IsBlackOut ? false : true);
          }
        },
      ]
    },

    //Amortisation Value Report
    {
      label: lang.amortisation_value_report,
      icon: "fa-solid fa-lg fa-money-bill",
      command: () => {
        setShowPopups({ ...defaultShowPopup, showAmortizationPopup: true })
      }
    },
  ];

  //const visibleAreaRef = useRef({ startHour: offSetTime, endHour: offSetTime + 3 });
  const visibleAreaRef = useRef({ startHour: offSetTime, endHour: offSetTime + 3 });

  const localPlanningData = useRef([]);
  const dataRef = useRef([]);
  const setData = (d) => {
    dataRef.current = d;
    setDisplayData(d);
  }

  const localPlanningUIRefresh = () => {
    setData(localPlanningData.current);
  }
  const [displayData, setDisplayData] = useState([]);
  const [headerLockPopup, setHeaderLockPopup] = useState({
    show: false,
    segments: [],
    header: null,
    nextHeaderStartTime: null
  });
  const refForBlankArea = useRef();
  const refForItem = useRef();
  const schedulerViewSlotRef = useRef();
  const MyScheduler = useRef(null);
  const [publishStatusData, setPublishStatusData] = useState([]);
  const [zoom, setZoom] = useState(20);
  // to activate weekday range
  // const [weekDayRange, setWeekDayRange] = useState({
  //   start: MyDays[0],
  //   end: MyDays[MyDays.length - 1],
  // });

  const selectedSlotRef = useRef({ SlotDateTime: null, channelIndex: 0 });
  const focusedSlotElementRef = useRef(null);
  const dragRafRef = useRef(null);
  const setSelctedSlot = (data) => {
    selectedSlotRef.current = data;
    //_setSelctedSlot(data);
  };


  const plannerCopiedItemsRef = useRef([]);
  const setPlannerCopiedItems = (data) => {
    console.log(data);
    plannerCopiedItemsRef.current = data;
    props.onSetPlannerCopiedItems(data);
  };

  const lastDroppedItemRef = useRef({});
  const setLastDroppedItem = (data) => {
    lastDroppedItemRef.current = data;
  };

  const lockedPlaylistRef = useRef([]);
  const setLockedPlaylist = (data) => {
    lockedPlaylistRef.current = data;
  };



  const resources = useMemo(() => [
    {
      name: "Channels",
      data: filterChannels.map((channel) => {
        return {
          text: channel.name,
          value: channel.SID,
          color: channel.Color != null ? channel.Color : "#7FB77E",
        };
      }),
      field: "ChannelSID",
      valueField: "value",
      textField: "text",
      colorField: "color",
    },
  ], [filterChannels]);

  const itemRenderPreferences = useMemo(() => {
    const currentPreference = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    const value = currentPreference?.data?.[0]?.value ?? {};

    return {
      columnPreference: PlanningHelper.getColumnPreference(),
      showFormat: !!value.ShowFormat,
      showNoSegment: !!value.ShowNoSeg,
      showContract: !!value.ShowContract,
      showInvalidFormat: value.ShowInvalidFormat ?? false,
    };
  }, [props.doLoad]);

  //for context menu and planner styling
  useEffect(() => {
    var schElem = document.getElementById("PlannerID");
    const handlePlannerMouseEnter = () => {
      allowCtrlAPopupRef.current = true;
    };
    const handlePlannerMouseLeave = () => {
      allowCtrlAPopupRef.current = false;
    };

    if (schElem) {
      schElem.style.height = "100%";
      schElem.addEventListener("contextmenu", onContextMenu);
      schElem.addEventListener("mouseenter", handlePlannerMouseEnter);
      schElem.addEventListener("mouseleave", handlePlannerMouseLeave);
      schElem.addEventListener("pointerdown", selectPlanningItemFromDomEvent, true);
      schElem.addEventListener("mousedown", selectPlanningItemFromDomEvent, true);
    }

    var scrollDiv = document.getElementsByClassName('k-scheduler-layout k-scheduler-layout-flex k-scheduler-day-view').item(0);
    if (scrollDiv) {
      scrollDiv.addEventListener("scroll", onScroll);
    }


    //Scewhduler Drop
    let schedulerElement = MyScheduler.current?.element;
    if (schedulerElement) {
      schedulerElement.addEventListener("dragover", handleDragOver);
    }
    document.addEventListener("copy", onCopy);
    document.addEventListener("cut", onCut);
    window.addEventListener("paste", onPaste);
    document.addEventListener("keyup", onEscape);
    document.addEventListener("keydown", onKeyDown);
    // setTimeZone();
    return () => {
      if (schElem) {
        schElem.removeEventListener("contextmenu", onContextMenu);
        schElem.removeEventListener("mouseenter", handlePlannerMouseEnter);
        schElem.removeEventListener("mouseleave", handlePlannerMouseLeave);
        schElem.removeEventListener("pointerdown", selectPlanningItemFromDomEvent, true);
        schElem.removeEventListener("mousedown", selectPlanningItemFromDomEvent, true);
      }

      //Deregister
      if (scrollDiv) {
        scrollDiv.removeEventListener("scroll", onScroll);
      }
      if (schedulerElement) {
        schedulerElement.removeEventListener("dragover", handleDragOver);
      }
      document.removeEventListener("copy", onCopy);
      document.removeEventListener("cut", onCut);
      window.removeEventListener("paste", onPaste);
      document.removeEventListener("keyup", onEscape);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, [slotDivision, slotDuration, view, filterChannels]);

  useEffect(() => {
    // setTimeZone();
  }, [slotDuration]);


  //socket
  const socket = useSocket(SOCKET_EVENTS.onSocketData, (socketData) => {

    if (socketData.module != MODULE.PLANNING) return;

    console.log(filterChannels);
    console.log(socketData.data);

    // in add, update object comes and in delete array comes.
    if (socketData.action == SOCKET_ACTION.PLANNING_UPDATE || socketData.action == SOCKET_ACTION.PLANNING_NEW_DROP) {
      if (!filterChannels.some(x => x.SID == socketData.data.Channel.SID)) return;
    }

    switch (socketData.action) {
      case SOCKET_ACTION.PLANNING_REFRESH:
        if (canRefreshPlanning(socketData)) refreshPlanning();
        break;
      case SOCKET_ACTION.PLANNING_NEW_DROP:
        console.log(socketData.data)
        let planningObjectForUI = socketData.data;
        planningObjectForUI.Style = PlanningHelper.getPlanningColorPreference(planningObjectForUI);
        let startDateTime = PlanningHelper.getSlotTimeBySelectedStartType(planningObjectForUI, props.startType, offSetTime);
        let Duration = PlanningHelper.getSelectedDurationType(planningObjectForUI, props.durationType, slotDurationRef.current);
        let endDateTime = new Date(startDateTime.getTime() + Duration);


        setData([
          ...dataRef.current,
          {
            ...planningObjectForUI,
            StartDate: startDateTime,
            EndTime: endDateTime
          },
        ]);
        break;
      case SOCKET_ACTION.PLANNING_UPDATE:
        update_planning(socketData.data);
        break;
      case SOCKET_ACTION.PLANNING_DELETE:
        setData(dataRef.current.filter((item) => socketData.data.find((current) => current._id === item._id) === undefined));
      default:
        break;
    }
  });

  const canRefreshPlanning = (socketData) => {

    try {

      // if user is not working on socket triggered channel
      if (!filterChannels.some(x => x.SID == socketData.data.channelSID)) {
        return false;
      }

      // validating date range here for socket trigger
      // START
      let startDate = (new Date(date)).setUTCHours(0, 0, 0, 0);
      let endDate = (new Date(date)).setUTCHours(0, 0, 0, 0);

      if (viewRef.current == "work-week") { //for day view      
        startDate = startDate + offSetTime;
        endDate = endDate + offSetTime + MILLISECONDSINADAY;
      }
      else { //for week view      
        startDate = (moment(date).utc().startOf("week").add(weekStartDayRef.current._id, "days").toDate().setUTCHours(0, 0, 0, 0)) + offSetTime;
        endDate = (moment(date).utc().endOf("week").add(weekStartDayRef.current._id, "days").toDate().setUTCHours(0, 0, 0, 0)) + offSetTime + MILLISECONDSINADAY;
      }

      const socketStartDate = socketData.data.scheduleScheduleStartDate;
      const socketEndDate = socketData.data.scheduleScheduleEndDate;

      if ((startDate <= socketStartDate && endDate >= socketEndDate) ||
        (startDate >= socketStartDate && startDate <= socketEndDate) ||
        (endDate >= socketStartDate && endDate <= socketEndDate) ||
        (startDate >= socketStartDate && endDate <= socketEndDate)) {
        return true;
      }
      // END
      return false;

    } catch (error) {
      return true;
    }
  }


  const setTimeZone = () => {
    let elements = document.getElementsByClassName("k-major-cell");
    let startMilisecond = offSetHours * 3600000;
    let gapMiliSecond = (24 * 60 / (elements.length) * 60000);

    for (let index = 0; index < elements.length; index++) {
      const element = elements[index];
      let date = new Date(startMilisecond);
      let hours = date.getUTCHours();
      let min = date.getUTCMinutes();
      hours = hours >= 24 ? hours - 24 : hours;
      element.innerHTML = String(hours).padStart(2, "0") + ":" + String(min).padStart(2, "0");
      startMilisecond += gapMiliSecond;
    }

  };

  useEffect(() => {
    setPlanningPreference();
  }, [props.doLoad, isPrimeTime]);

  //for loading data
  useEffect(() => {
    loadCombo();
    refreshPlanning();
  }, [date, filterChannels, props.doLoad, props.durationType, isPrimeTime, props.startType]);

  //for loading data
  useEffect(() => {
    if (props.planningGroupItems?.MediaEpisodes) {
      loadPlanningGroupItem();
    }
  }, [props.planningGroupItems]);

  const loadCombo = async () => {
    let txStatusRes = await API.getDataLookup(ENTITYNAME.TXStatus, { sort: { SID: 1 } });
    setTxStatusData(txStatusRes.data);
  }

  const refreshPlanning = () => {
    loadPlanningData();
    loadPublishStatusData();
    setPlannerSelectedItems([]);
    // setTimeZone();
    getLockedPlaylist();
  }

  const setPlanningPreference = () => {
    setWeekStartDayData(preferenceData?.data[0]?.value?.weekStartDay ?? Object.keys(Day).filter(key => key.length > 1).map(key => ({
      _id: Day[key],
      Description: key,
      bgColor: "#FFFF00",
    }))[1])

    let selectedSlotDuration = (utility.getSeassionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DURATION) ?? preferenceData?.data[0]?.value?.SlotDuration) ?? 60

    setSlotDuration(selectedSlotDuration);
    let index = SLOT_TIMES.indexOf(selectedSlotDuration);
    let selectedSlotDivision = (utility.getSeassionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DIVISION) ?? preferenceData?.data[0]?.value?.SlotDivision) ?? SLOT_DIVISIONS[index];
    setSlotDivision(selectedSlotDivision);
    setViewData(preferenceData?.data[0]?.value?.View?.View ?? 'week');
    setStartType(preferenceData?.data[0]?.value?.StartType ?? 'Nominal');
    //resetPlanningGridHeight();

  }

  const loadPlanningGroupItem = async () => {
    var startTime = selectedSlotRef.current.SlotDateTime.getTime();

    for (
      let index = 0;
      index < props.planningGroupItems.MediaEpisodes.length;
      index++
    ) {
      let mediaEpisode = props.planningGroupItems.MediaEpisodes[index];
      props.setStatus(`${lang.creating_label}` + mediaEpisode.AssetId);
      await addPlanningItem(
        new Date(startTime),
        filterChannels[selectedSlotRef.current.channelIndex],
        mediaEpisode,
        null
      );
      startTime = startTime + mediaEpisode.Duration;
    }
    props.setStatus(lang.successfully_created_group_label);
  };

  const loadPublishStatusData = async () => {
    const res = await API.getData(ENTITYNAME.PublishStatus);
    if (res.success) {
      setPublishStatusData(res.data);
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  };

  useImperativeHandle(ref, () => {
    return {
      selectAllPlanningData() {
        console.log(dataRef.current);
        setPlannerSelectedItems(dataRef.current);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "All items selected" });
      },

      selectAllPlanningDataForSelectedDate() {
        if (selectedSlotRef.current.SlotDateTime == null && plannerSelectedItemsRef.current.length == 0) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "First select a slot to select all planning items for that date" });
          return;
        }
        let selectedDate = plannerSelectedItemsRef.current.length > 0 ? new Date(plannerSelectedItemsRef.current[0].SlotDateTime).setUTCHours(0, 0, 0, 0) : selectedSlotRef.current.SlotDateTime.setUTCHours(0, 0, 0, 0);
        console.log(selectedDate);
        let filteredData = dataRef.current.filter(x => x.SlotDateTime >= selectedDate && x.SlotDateTime < (selectedDate + (24 * 60 * 60 * 1000)));
        setPlannerSelectedItems(filteredData);
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "All items selected for " + moment(selectedDate).format('ll') });
      },

      selectItemsOfSimilarEpisodes() {
        if (plannerSelectedItemsRef.current && plannerSelectedItemsRef.current.length > 0) {
          let selectedEpisode = plannerSelectedItemsRef.current[0].mediaEpisode;
          let filteredData = dataRef.current.filter(x => x.mediaEpisode.AssetId == selectedEpisode.AssetId);
          setPlannerSelectedItems(filteredData);
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "All items selected for " + selectedEpisode.AssetId });
        }
        else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a planning item" });
        }
      },

      selectAllEpisodesOfSelectedSeries() {
        if (plannerSelectedItemsRef.current && plannerSelectedItemsRef.current.length > 0) {
          let selectedEpisode = plannerSelectedItemsRef.current[0].mediaEpisode;
          if (selectedEpisode.Series_id && selectedEpisode?.Series_id == null) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a series" });
            return;
          }
          let filteredData = dataRef.current.filter(x => x.mediaEpisode?.Season_id == selectedEpisode?.Season_id);
          setPlannerSelectedItems(filteredData);
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "All items selected for " + selectedEpisode.Season_id });
        }
        else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a planning item" });
        }
      },

      async deletePlanningItemFromMenu(option = PLANNING_DELETE_OPTION.DELETE_SELECTED) {
        // 0 -> Delete Selected
        // 1 -> Delete Slot and Push Forward in the Strand
        // 2 -> Delete Episode and Pull Backward in the Strand   
        // 3 -> Delete All the Events Forward in the Strand
        // 4 -> Delete Episode in future from selected slot forward
        if (plannerSelectedItemsRef.current.length == 0) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please first select planning item' });
          return;
        }

        if (option == PLANNING_DELETE_OPTION.DELETE_SELECTED) {
          await deletePlanningItem();
        } else {
          let selectedItem = plannerSelectedItemsRef.current[0];
          if (!selectedItem.hasOwnProperty('RecursionParentProgramSchedule_id') || (selectedItem.hasOwnProperty('RecursionParentProgramSchedule_id') && selectedItem.RecursionParentProgramSchedule_id && selectedItem.RecursionParentProgramSchedule_id.length == 0)) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Selected item is not a part of strand` });
            return;
          }
          props.setStatus('Deleting Planning...');
          let res = await API.deletePlanningByOptions(option, selectedItem);
          if (!res.success) {
            ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message ?? 'Error' });
          }
        }
      },

      getSelectedSlotDuration() {
        return slotDuration;
      },

      addPlanningItem(startDate, selectedChannel, mediaEpisode, MediaDealRight, fetchSegmentFromDB, customTitle, customDuration, segment_id, txStatus) {
        addPlanningItem(startDate, selectedChannel, mediaEpisode, MediaDealRight, fetchSegmentFromDB, customTitle, customDuration, segment_id, txStatus);
      },



    };
  }, [dataRef.current]);


  const onKeyDown = (e) => {

    if (e && e.target && e.target.localName == "input") {
      return;
    }

    if (e.ctrlKey && (e.key === 'a' || e.key === 'A') && e.target.localName != "input" && allowCtrlAPopupRef.current) {
      e.preventDefault();
      showCtrlADialog();
      return;
    }
    if (e.key == 'F12' || e.keyCode == 123) {
      e.preventDefault();
      if (plannerSelectedItemsRef.current.length == 1) {
        utility.setSessionValue(
          LOCALSTORAGE_KEY.publishData,
          plannerSelectedItemsRef.current[0]
        );
        navigate("/home/Scheduling");
      } else {
        console.log("not selected item");
        alert("Please select one planning item to open schedule");
      }
    }
    //for delete key
    else if (e.key == 'Delete' || e.keyCode == 46) {
      e.preventDefault();

      if (plannerSelectedItemsRef.current == undefined || plannerSelectedItemsRef.current.length == 0) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: 'First select planner items you want to delete' });
        return;
      }

      showDeleteMenu();
    }
  }
  const onEscape = (e) => {
    if (e.keyCode == 27 || e.key == "Escape") {
      setPlannerCopiedItems([]);
    }
  }


  const onCut = async () => {
    onCopy();
    await deletePlanningItem();

  }
  const onCopy = () => {
    setPlannerCopiedItems([...plannerSelectedItemsRef.current]);
    console.log("copied" + plannerSelectedItemsRef.current.length);
  };


  const onPasteStrand = async (withCustomDuration = false) => {
    if (plannerCopiedItemsRef.current.length == 0 || plannerCopiedItemsRef.current.length > 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'First copy planner items you want to paste in strand' });
      return;
    }
    let selectedItem = plannerCopiedItemsRef.current[0];
    console.log(selectedItem);
    if (!selectedItem.hasOwnProperty('RecursionParentProgramSchedule_id') || (selectedItem.hasOwnProperty('RecursionParentProgramSchedule_id') && selectedItem.RecursionParentProgramSchedule_id.length == 0)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Selected item is not a part of strand` });
      return;
    }
    props.setStatus('Pasting Strand...');

    let res = await API.copyStrandAndPaste(
      selectedItem,
      selectedSlotRef.current.SlotDateTime.getTime() + offSetTime,
      withCustomDuration ? customSlotDuration : null
    );
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message ?? 'Error' });
    }
    props.setStatus('Pasted Strand');
    // refresh data
    refreshPlanning();
    setIsPasteStrandWithCD(false);
    setCustomSlotDuration("00:00:00:00");

  }


  const onPaste = async (e, isCut = false) => {
    console.log(e);

    if (e && e.target && e.target.localName == "input") {
      return;
    }
    console.log(plannerCopiedItemsRef.current);
    let fetchSegmentFromDB = !isCut;
    if (plannerCopiedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.first_copy_planner_items_you_want_to_paste_planning_performance_error_message });
      setPlannerSelectedItems([]);
      return;
    }
    console.log(selectedSlotRef.current);
    if (selectedSlotRef.current.SlotDateTime == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_area_on_planner_where_to_paste_planning_performance_error_message });
      return;
    }

    //Check if item alreadty exists do not allow to paste
    if (dataRef.current.some(item =>
      item.SlotDateTime == (selectedSlotRef.current.SlotDateTime.getTime() + offSetTime) &&
      item.Channel.SID == filterChannels[selectedSlotRef.current.channelIndex].SID
    )) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.item_already_planned_error_message });
      return;
    }

    var plannerCopiedItemsOrdered = plannerCopiedItemsRef.current
      .map(item => ({ ...item }))
      .sort((a, b) => a.SlotDateTime - b.SlotDateTime);

    var startDateTime = selectedSlotRef.current.SlotDateTime;
    var selectedChannelIndex = selectedSlotRef.current.channelIndex;

    const recursionParentProgramSchedule_id = uuidv4();

    plannerCopiedItemsOrdered.map(async (item, index) => {
      if (!isCut) {
        delete item["SID"];
        delete item["_id"];
      }
      if (index > 0) {
        var previousSlotItem = plannerCopiedItemsOrdered[index - 1];
        var startDateTimeMillisecond =
          startDateTime.getTime() +
          (item.SlotDateTime - previousSlotItem.SlotDateTime);
        startDateTime = new Date(startDateTimeMillisecond);
      }
      var selectedChannel = getSelectedChannel(selectedChannelIndex);

      console.log("selectedChannel");
      console.log(selectedChannel);

      //CASE : LIVE EVENT COPY / PASTE DO NOT CREATE SEGMENTATION
      let txStatus = item?.mediaEpisode?.IsLive && item?.mediaEpisode?.AlwaysLive ? { SID: 1, Description: 'Live' } : item?.TXStatus?.Description == 'Live' ? { SID: 2, Description: 'Repeat' } : undefined;
      if (
        item?.mediaEpisode?.IsLive &&
        item?.Segment_id != null &&
        (item?.segments?.length > 0 || item?.mediaEpisode?.segments?.length > 0)
      ) {

        let currentSegment = item?.segment ? item?.segment : item?.mediaEpisode?.segments.find((x) => x._id == item?.Segment_id)

        if (currentSegment?.SegmentType?.TXMode?.Name == utility.getKeyByValue(TX_MODE, TX_MODE.LIVE)) {

          fetchSegmentFromDB = false;
          item.Segment_id = null;

        }
      }

      await addPlanningItem(
        startDateTime,
        selectedChannel,
        item.mediaEpisode,
        item.MediaDealRight,
        fetchSegmentFromDB, // if copy then we need to pull segments
        "",
        0,
        item.Segment_id,
        txStatus,
        recursionParentProgramSchedule_id
      );

      props.setStatus(`${lang.pasted_label}${index + 1}/${plannerCopiedItemsRef.current.length}${lang.items_label}`);

      //IF COPIED ITEM IS MORE THAN 50 DO SILENT REFRESH WHILE PASTING
      if (plannerCopiedItemsOrdered.length > 50) {

        //SILENT REFRESH
        console.log("SILENT REFRESH")
        let channel = focusedPlanningItemPropRef.current.dataItem.Channel;
        let date = new Date(focusedPlanningItemPropRef.current.dataItem.SlotDateTime).setUTCHours(0, 0, 0, 0);
        refreshSchedule(channel, date);

      }

    });
  };

  const getSelectedChannel = (selectedChannelIndex) => {
    let filteredChannelLocal = [...filterChannels];
    return filteredChannelLocal[selectedChannelIndex];
  };

  const onScroll = (e) => {
    // Kendo handles the scroll positioning itself. Replacing scheduler data
    // while the user scrolls makes the whole planner repaint and blocks input.
  }

  //this function calls when we drop media into planning
  const handleDragOver = (e) => {
    e.preventDefault();

    // Find the Kendo slot cell – e.target may be a child or wrapper,
    // so walk up the DOM to find the element with data-slot-start.
    const slotElem = e.target?.closest?.(".k-scheduler-cell.k-slot-cell");
    if (!slotElem || !slotElem.dataset.slotStart) return;

    // Capture mouse position now – event properties may not survive into rAF
    const cursorY = e.clientY;

    // Throttle visual updates to one per animation frame (~60fps)
    if (dragRafRef.current) return;

    dragRafRef.current = requestAnimationFrame(() => {
      dragRafRef.current = null;

      const oldElem = document.getElementById("drag-ghost-del");
      if (!oldElem) return;

      // One layout read – batch it before any writes
      const slot = slotElem.getBoundingClientRect();

      const duration = (parseInt(oldElem.title ?? 0) / 60000) / slotDurationRef.current;
      const heightPx = Math.max(1, Math.round(slot.height * duration * slotDivision));

      // Ensure ghost element exists
      let elem = document.getElementById("drag-ghost");
      if (!elem) {
        elem = document.createElement("div");
        elem.id = "drag-ghost";
        elem.style.cssText =
          "position:fixed;left:0;top:0;background:#3F497F;white-space:pre-line;" +
          "z-index:10000;opacity:0.6;pointer-events:none;user-select:none;" +
          "cursor:pointer;will-change:transform;color:#fff;font-size:12px;" +
          "padding:4px;border-radius:3px;overflow:hidden;";
        document.body.appendChild(elem);
      }

      // Only update text when it actually changes
      const newContent = PlanningHelper.getPlanningDropTime(offSetHours, slotElem.dataset.slotStart)
        + "\r\n" + oldElem.innerText;
      if (elem._lastContent !== newContent) {
        elem.innerHTML = newContent;
        elem._lastContent = newContent;
      }

      // Sub-slot snapping
      let top = slot.top;
      if (slotDivision > 0) {
        const subH = slot.height / slotDivision;
        top += Math.floor(Math.max(0, cursorY - slot.top) / subH) * subH;
      }

      // GPU-composited move via transform – avoids layout thrashing
      elem.style.width = slot.width + "px";
      elem.style.height = heightPx + "px";
      elem.style.transform = `translate(${Math.round(slot.left)}px,${Math.round(top)}px)`;
    });
  };

  const onContextMenu = (e) => {
    const target = e.target;
    const targetClassName = typeof target?.className === "string" ? target.className : "";
    const slotElement = target?.closest?.(".k-scheduler-cell.k-slot-cell");
    const itemElement = target?.closest?.("[id^='planning-item-'], .k-event");
    const resizeHandleElement = target?.closest?.(".k-resize-handle");

    //resize handle
    if (resizeHandleElement) {
      e.preventDefault();
      return;
    }

    //blank area or custom slot
    if (slotElement && !itemElement) {
      e.preventDefault();
      let slotStartDate = new Date(parseInt(slotElement.dataset.slotStart));
      let channelGroup = parseInt(slotElement.dataset.slotGroup);
      schedulerViewSlotEvent(slotStartDate, channelGroup);

      const targetChannelSID = filterChannels[channelGroup]?.SID;
      const targetSlotTime = new Date(slotStartDate.getTime() + offSetTime);
      const cellEnd = new Date(targetSlotTime.getTime() + (slotDurationRef.current || 60) * 60000);
      const matchingSlot = PlanningHelper.getMatchingCustomSlot(targetSlotTime, cellEnd, targetChannelSID, customSlotsRef.current);

      clickedCustomSlotRef.current = matchingSlot;
      flushSync(() => {
        setClickedCustomSlot(matchingSlot);
      });
      refForBlankArea.current?.show(e);
      refForItem.current?.hide(e);
      return;
    }
    //planner item
    if (itemElement || targetClassName.includes("customItem")) {
      e.preventDefault();
      const itemId = itemElement?.id?.replace("planning-item-", "");
      const dataItem = dataRef.current.find((item) => item._id == itemId);
      let matchingSlot = null;
      if (dataItem) {
        if (dataItem.ProgramScheduleSlot?._id) {
          matchingSlot = customSlotsRef.current.find(
            (s) => String(s._id) === String(dataItem.ProgramScheduleSlot._id)
          );
        }
        if (!matchingSlot && dataItem.SlotDateTime && (dataItem.Channel?.SID != null || dataItem.ChannelSID != null)) {
          const chSID = dataItem.Channel?.SID ?? dataItem.ChannelSID;
          matchingSlot = PlanningHelper.getMatchingCustomSlot(
            new Date(dataItem.SlotDateTime),
            new Date(dataItem.SlotDateTime + (dataItem.customDuration || dataItem.SegmentDuration || 60000)),
            chSID,
            customSlotsRef.current
          );
        }
      }
      clickedCustomSlotRef.current = matchingSlot;
      flushSync(() => {
        setClickedCustomSlot(matchingSlot);
      });
      refForItem.current?.show(e);
      refForBlankArea.current?.hide(e);
      return;
    }
  };

  const deletePlanningItem = async () => {
    if (plannerSelectedItemsRef.current.length < 1) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_content_to_delete_planning_performance_error_message });
      return;
    }

    var dataItemArray = [];
    dataItemArray = plannerSelectedItemsRef.current;

    var deleteIds = [];
    var deletedPlanItemsForLog = [];
    //ui delete
    let newData = dataRef.current.filter((data) => {
      if (!dataItemArray.some((item) => item._id == data._id)) {
        return data;
      } else {
        deletedPlanItemsForLog.push(data);
        deleteIds.push({
          _id: data._id,
          MediaDealRight_id: data.MediaDealRight_id,
          Channel: data.Channel,
          date: new Date(data.SlotDateTime).setUTCHours(0, 0, 0, 0)
        });
      }
    });
    setData(newData);
    //api delete
    deleteIds.map((obj) => {
      API.deletePlanning(obj).then((response) => {
        if (response.success && response.data) {

          //UPDATE LIVE EVENT STATUS WHILE DELETING LIVE EVENT
          let deleteItem = dataItemArray.find((x) => x._id == obj._id);
          if (deleteItem != null) {
            handlePublishUnPublishLiveEvent({
              scheduleMatchDataItem: deleteItem.mediaEpisode,
              slotDateTime: deleteItem.SlotDateTime,
              publish: false
            });
          }

          if (response.data.dealRightHeaders && response.data.dealRightHeaders.length > 0) {
            updateExhibitionAndRepeatOnUI(response.data.dealRightHeaders);
          }

        } else if (!response.success) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
        }
      });
    });
    deletedPlanItemsForLog.map((item) => {
      let logData = { event: LOGEVENT.DELETE_PLANNING, module: MODULE.PLANNING, data: item, message: lang.delete_planning_log_message };
      API.SaveProgramScheduleHeaderLogs(logData);
    })

    if (deleteIds.length > 0) {
      socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_DELETE, module: MODULE.PLANNING, data: deleteIds })
      let uniqueDeleteItems = utility.removeDuplicate(deleteIds, "date");

      uniqueDeleteItems.map((item) => {
        refreshSchedule(item.Channel, item.date);
      })


    }

    setPlannerSelectedItems([]);
  };

  const loadPlanningData = async () => {

    props.setStatus(<>{lang.planning_loading_label} <i className="fa fa-spin fa-spinner fa-xl" /></>);
    isPlanningLoading.current = true;

    // Default For Day View
    let startDate = (new Date(date)).setUTCHours(0, 0, 0, 0);
    let endDate = (new Date(date)).setUTCHours(0, 0, 0, 0);
    console.log(viewRef.current);

    if (viewRef.current == "work-week") {
      //for day view
      startDate = startDate + offSetTime;
      endDate = endDate + offSetTime + MILLISECONDSINADAY;
    }
    else if (viewRef.current == "day") {
      // for custom view
      startDate = (new Date(customDates.startDate)).setUTCHours(0, 0, 0, 0) + offSetTime;
      endDate = (new Date(customDates.endDate)).setUTCHours(0, 0, 0, 0) + offSetTime + MILLISECONDSINADAY;
    }
    // else if(view == "month"){
    //   //for month
    //   startDate.setDate(0);//this brings the last date of previous month
    //   endDate.setDate(32);//this brings the first date of next month or 2nd date in case the month is of 31 days
    // }
    else {
      //for week view
      console.log(weekStartDayRef.current);
      startDate = ((moment(date).utc().startOf("week").add(weekStartDayRef.current._id, "days").toDate().setUTCHours(0, 0, 0, 0)) + offSetTime) - MILLISECONDSINADAY;
      endDate = (moment(date).utc().endOf("week").add(weekStartDayRef.current._id, "days").toDate().setUTCHours(0, 0, 0, 0)) + offSetTime + MILLISECONDSINADAY;
    }

    var payload = {
      startDate: startDate,
      endDate: endDate,
      channels: filterChannels.map((channel) => channel.SID),
    };

    props.setPayload(payload);
    payloadRef.current = payload;

    await loadCustomSlotsData(payload.channels, payload.startDate, payload.endDate);

    console.log(payload);

    let response = await API.getPlanning(payload);

    PlanningHelper.loadPlanningPrefrence();

    console.log(response);

    if (response.success) {
      if (response.data && response.data.length > 0) {
        let planningData = response.data.map((obj) => {
          var startDateTime = PlanningHelper.getSlotTimeBySelectedStartType(obj, props.startType, offSetTime);
          var Duration = PlanningHelper.getSelectedDurationType(
            obj,
            props.durationType,
            slotDurationRef.current
          );
          var endDateTime = new Date(startDateTime.getTime() + Duration);

          return {
            ...obj,
            Title: obj.customTitle ? obj.customTitle : obj.mediaEpisode.Title,
            Description: obj.SlotSynopsis ? obj.SlotSynopsis : obj.mediaEpisode.Description,
            StartDate: startDateTime,
            EndTime: endDateTime,
            SlotDate: new Date(obj.ScheduleDate),
            ChannelSID: obj.Channel.SID,
            Style: PlanningHelper.getPlanningColorPreference(obj),
            InvalidReason: PlanningHelper.getInvalidReason(obj),
          };
        });
        setData(planningData);
        localPlanningData.current = planningData;
      }
      else {
        console.log(response.data);
        setData([]);
      }

      props.setStatus(lang.planning_loaded_label);
      isPlanningLoading.current = false;
    } else {
      isPlanningLoading.current = false;
      props.setStatus(lang.planning_loading_error_label);
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.error_fetching_planning_data_error_message });
      return;
      // alert("Error fetching planning data");
    }
  };


  const resetPlanningGridHeight = () => {

    console.log("Resetting Height");

    setData(dataRef.current.map((item) => {
      let duration = PlanningHelper.getSelectedDurationType(item, props.durationType, slotDurationRef.current);
      var endDateTime = new Date(item.SlotDateTime + duration);

      let updatedItem = {
        ...item,
        EndTime: endDateTime,
      };
      return updatedItem;
    })
    );
  }

  const getLockedPlaylist = async () => {
    const lockPlaylist = await utility.getLockedPlaylist(date, MODULE.PLANNING);
    if (lockPlaylist.success) {
      console.log(lockPlaylist);
      setLockedPlaylist(lockPlaylist.data);
    }
  }

  //changes date in scheduler
  const onDateChange = (event) => {
    props.onDateChange(event.value);
  };

  //function to update data when handledrop item dropped
  const onUpdateFromPlanningEditForm = useCallback((updatedData) => {
    //need to update the item

    console.log("updatedData",updatedData);

    setData(dataRef.current.map((item) => {
      if (item._id == updatedData._id) {
        console.log(updatedData)
        let duration = PlanningHelper.getSelectedDurationType(updatedData, props.durationType, slotDurationRef.current);

        let updatedItem = {
          ...item,
          ...updatedData,
          Title: updatedData.customTitle && updatedData.customTitle.length > 0 ? updatedData.customTitle : item.Title,
          Segment_id: updatedData.Segment_id,
          SlotDateTime: updatedData.SlotDateTime,
          ScheduleDate: updatedData.SlotDateTime,
          StartDate: PlanningHelper.getSlotTimeBySelectedStartType({ ...updatedData, ScheduleDate: updatedData.SlotDateTime }, props.startType, getOffsetTime()),
          EndTime: PlanningHelper.getSlotEndTimeBySelectedStartType({ ...updatedData, ScheduleDate: updatedData.ScheduleDate }, props.startType, getOffsetTime(), duration),
          ActualDuration: updatedData.ActualDuration,
          NominalDuration: updatedData.NominalDuration,
          ProgramScheduleSlot: updatedData.ProgramScheduleSlot !== undefined ? updatedData.ProgramScheduleSlot : item.ProgramScheduleSlot
        };
        socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_UPDATE, module: MODULE.PLANNING, data: { ...updatedItem, SlotDateTime: updatedData.SlotDateTime - getOffsetTime() } })
        let channel = updatedItem.Channel;
        let date = new Date(updatedItem.SlotDateTime).setUTCHours(0, 0, 0, 0);

        refreshSchedule(channel, date);

        // Log Capture on edit
        let logData = { event: LOGEVENT.PLANNING_UPDATE, module: MODULE.PLANNING, data: updatedItem, message: lang.edited_using_form_log_message };
        API.SaveProgramScheduleHeaderLogs(logData);

        return updatedItem

      }
      else {
        return item;
      }
    })
    );



  }, []);

  //To get data from custom form by adding new prop
  const CustomFormWithAdditionalProps = (fieldRenderProps) => {
    return isRightSide ? (
      <PlanningRightSideEditFormWithSlot
        {...fieldRenderProps}
        onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm}
        module={MODULE.PLANNING}
        customSlots={customSlots}
      />
    ) : (
      <PlanningEditFormWithSlot
        {...fieldRenderProps}
        onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm}
        module={MODULE.PLANNING}
        customSlots={customSlots}
      />
    );
  };

  //function to handle multi select with shift key
  const handleShiftMultiSelect = (dataItem) => {

    if (plannerSelectedItemsRef.current.length > 0) {

      var selectedItemIndex = dataRef.current.findIndex((item) => item._id == dataItem._id);
      var lastSelectedItemIndex = dataRef.current.findIndex(
        (item) => item._id == plannerSelectedItemsRef.current[plannerSelectedItemsRef.current.length - 1]._id
      );

      let minSlotDateTime = dataRef.current[lastSelectedItemIndex].SlotDateTime > dataRef.current[selectedItemIndex].SlotDateTime ? dataRef.current[selectedItemIndex].SlotDateTime : dataRef.current[lastSelectedItemIndex].SlotDateTime;
      let maxSlotDateTime = dataRef.current[lastSelectedItemIndex].SlotDateTime > dataRef.current[selectedItemIndex].SlotDateTime ? dataRef.current[lastSelectedItemIndex].SlotDateTime : dataRef.current[selectedItemIndex].SlotDateTime;

      var selectedItems = dataRef.current.filter((item) => item.SlotDateTime >= minSlotDateTime && item.SlotDateTime <= maxSlotDateTime && item.ChannelSID == dataItem.ChannelSID)

      setPlannerSelectedItems([...selectedItems]);
    } else {
      setPlannerSelectedItems([dataItem]);
    }
  }

  const onPlannerItemSelect = (event, dataItem, activeTarget = null) => {
    // Clear previous focused slot background
    if (focusedSlotElementRef.current?.element?.style) {
      focusedSlotElementRef.current.element.style.backgroundColor = focusedSlotElementRef.current.originalBg || "";
    }
    const sourceEvent = event.syntheticEvent ?? event;

    if (sourceEvent.button === 2 || sourceEvent.which === 3) {
      // right click is handled in selectPlanningItemFromDomEvent function
      return;
    }

    if (sourceEvent.ctrlKey || sourceEvent.metaKey) {
      //if already then it should be deselct and delete from
      if (
        plannerSelectedItemsRef.current.some((item) => item._id == dataItem._id)
      ) {
        const plannerSelectedItemscopy = plannerSelectedItemsRef.current.filter((item) => item._id !== dataItem._id);
        setPlannerSelectedItems(plannerSelectedItemscopy, activeTarget);
      } else {
        setPlannerSelectedItems([...plannerSelectedItemsRef.current, dataItem], activeTarget);
      }
    }
    else if (sourceEvent.shiftKey) {
      handleShiftMultiSelect(dataItem)
    }
    else {
      setPlannerSelectedItems([dataItem], activeTarget);
    }
  };


  const onPlannerItemDoubleClick = useCallback((event, dataItem, activeTarget = null) => {
    setPlannerSelectedItems([dataItem], activeTarget);
    setShowPopups((prev) => ({ ...prev, showRightSideEditForm: true }));
  }, []);

  const CustomViewSlot = useCallback((props) => {
    if (props.isAllDay) {
      return null;
    }

      const channelSID = props.group.resources[0].value;
      const channel = filterChannels.find((channel) => channel.SID === channelSID);
      const date = new Date(new Date(props.start).setUTCHours(0, 0, 0, 0)).getTime();

      const lockStatus =
        filterChannels.length === 0
          ? { isSelfLocked: false, canModify: true, fromSchedule: false, lockedBy: {} }
          : utility.canModify(lockedPlaylistRef.current, MODULE.PLANNING, channel?._id, date);

      const style = {
        ...props.style,
        minHeight: zoom,
        position: "relative",
      };

      if (lockStatus.isSelfLocked || !lockStatus.canModify) {
        style.backgroundColor = lockStatus.fromSchedule ? SLOT_LOCK_COLOR : SLOT_COLOR;
        if (!lockStatus.canModify) {
          style.pointerEvents = "none";
        }
      }

      const cellStartMs = new Date(props.start).getTime() + offSetTime;
      const cellEndMs = props.end ? new Date(props.end).getTime() + offSetTime : cellStartMs + (slotDurationRef.current * 60000);
      const cellDuration = cellEndMs - cellStartMs;

      const matchingCustomSlot = PlanningHelper.getMatchingCustomSlot(cellStartMs, cellEndMs, channelSID, customSlots);

      let isFirstCell = false;
      let isLastCell = false;
      let topPct = 0;
      let heightPct = 100;

      if (matchingCustomSlot && cellDuration > 0) {
        const slotStart = typeof matchingCustomSlot.SlotStart === "number" ? matchingCustomSlot.SlotStart : new Date(matchingCustomSlot.SlotStart).getTime();
        const slotEnd = typeof matchingCustomSlot.SlotEnd === "number" ? matchingCustomSlot.SlotEnd : new Date(matchingCustomSlot.SlotEnd).getTime();

        isFirstCell = cellStartMs <= slotStart || (cellStartMs - cellDuration) < slotStart;
        isLastCell = cellEndMs >= slotEnd;

        const effectiveStart = Math.max(cellStartMs, slotStart);
        const effectiveEnd = Math.min(cellEndMs, slotEnd);

        topPct = ((effectiveStart - cellStartMs) / cellDuration) * 100;
        heightPct = ((effectiveEnd - effectiveStart) / cellDuration) * 100;
      }

      return (
        <div
          title={
            lockStatus.canModify
              ? null
              : `Locked by ${lockStatus.lockedBy?.name || "another user"}${lockStatus.fromSchedule ? " from Schedule" : ""}`
          }
          style={lockStatus.canModify ? { width: "100%" } : { width: "100%", cursor: "no-drop" }}
          onDrop={
            lockStatus.canModify
              ? (e) => {
                  handleDropItem(e);
                }
              : () => {
                  ToastNotification({
                    type: TOAST_TYPES.ERROR,
                    title: lang.invalid_error_message_title,
                    message: "Locked by " + (lockStatus.lockedBy?.name || "another user"),
                  });
                }
          }
          onContextMenu={(e) => e.preventDefault()}
        >
          <SchedulerViewSlot
            onClick={(e) => {
              const srcEvt = e?.syntheticEvent ?? e;
              const target = srcEvt?.target;
              if (target?.closest?.("[id^='planning-item-'], .k-event, .customItem")) {
                return;
              }
              schedulerViewSlotEvent(
                e.target.props.start,
                e.target.props.group.index
              );
            }}
            {...props}
            onFocus={(e) => {
              if (focusedSlotElementRef.current && focusedSlotElementRef.current !== props._ref?.current?.element) {
                focusedSlotElementRef.current.style.backgroundColor = "";
              }
              let elem = props._ref?.current?.element;
              if (elem) {
                elem.style.backgroundColor = "#c4dbe9";
                focusedSlotElementRef.current = elem;
              }
            }}
            style={style}
          >
            {matchingCustomSlot && (
              <div
                className="custom-slot-box"
                style={{
                  position: "absolute",
                  top: `${topPct}%`,
                  height: `${heightPct}%`,
                  left: 0,
                  right: 0,
                  pointerEvents: "none",
                  backgroundColor: `${matchingCustomSlot.BgColor || "#4559bf"}22`,
                  borderLeft: `2px solid ${matchingCustomSlot.BgColor || "#4559bf"}`,
                  borderRight: `2px solid ${matchingCustomSlot.BgColor || "#4559bf"}`,
                  borderTop: isFirstCell ? `2px solid ${matchingCustomSlot.BgColor || "#4559bf"}` : "none",
                  borderBottom: isLastCell ? `2px solid ${matchingCustomSlot.BgColor || "#4559bf"}` : "none",
                  boxSizing: "border-box",
                  zIndex: 0,
                }}
              >
                {isFirstCell && (
                  <div
                    style={{
                      position: "absolute",
                      top: 2,
                      left: 4,
                      right: 4,
                      fontSize: "11px",
                      fontWeight: 600,
                      color: matchingCustomSlot.BgColor || "#4559bf",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      lineHeight: "14px",
                    }}
                  >
                    {matchingCustomSlot.Description}
                  </div>
                )}
              </div>
            )}
          </SchedulerViewSlot>
        </div>
      );
    },
    [visibleAreaRef.current, filterChannels, customSlots, offSetTime]
  );

  const schedulerViewSlotEvent = (startTime, channelIndex) => {
    setPlannerSelectedItems([]);

    setSelctedSlot({ SlotDateTime: startTime, channelIndex: channelIndex });

    console.log({ SlotDateTime: startTime, channelIndex: channelIndex });
  };

  const handlePublishUnPublishLiveEvent = async ({ programScheduleId, scheduleMatchDataItem, slotDateTime, channel, publish }) => {

    console.log(scheduleMatchDataItem)
    console.log(slotDateTime)

    //HANDLE REPEAT COPY PASTE AND DELETE CASE
    if (!scheduleMatchDataItem.IsLive) return;

    let payload = {
      MediaEpisode_id: scheduleMatchDataItem._id,
      ProgramSchedule_id: publish ? programScheduleId : "",
      Channel: publish ? { _id: channel._id, SID: channel.SID, FullChannelName: channel.FullChannelName } : {},
      SlotDateTime: publish ? slotDateTime : 0,
      Publish: publish
    }

    var res = await API.publishUnPublishLiveEvent(payload);

    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: `Match ${publish ? 'publish' : 'un-published'} successfully` });
      props.refreshLiveEvent();
      socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.LIVE_EVENT_REFRESH, module: MODULE.LIVE_EVENTS, data: null })

    } else {
      console.log(res)
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }


  };

  const handleDropItem = async (e) => {
    if (isPlanningLoading.current) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Planning is still loading, Please wait...." });
      return;
    }

    const targetCell = e.target?.closest?.("[data-slot-start]") || e.target?.querySelector?.("[data-slot-start]") || e.target;

    //start
    let start = targetCell?.getAttribute ? targetCell.getAttribute("data-slot-start") : null;
    if (!start && targetCell?.dataset) {
      start = targetCell.dataset.slotStart;
    }
    if (!start && e.target?.getAttribute) {
      start = e.target.getAttribute("data-slot-start");
    }
    let startDate = new Date(parseInt(start));
    let dataTransfer = JSON.parse(e.dataTransfer.getData("text"));
    //dragged media draggedItem
    let mediaEpisode = dataTransfer.dataItem;
    //channel
    let selectedChannelIndex = targetCell?.getAttribute ? targetCell.getAttribute("data-slot-group") : (targetCell?.dataset?.slotGroup || e.target?.getAttribute?.("data-slot-group"));
    let filteredChannelLocal = [...filterChannels];
    const selectedChannel = filteredChannelLocal[selectedChannelIndex];


    // Check if dropped on a custom slot
    const droppedCustomSlot = PlanningHelper.getMatchingCustomSlot(
      new Date(startDate.getTime() + offSetTime),
      null,
      selectedChannel?.SID,
      customSlots
    );
    if (droppedCustomSlot) {
      ToastNotification({
        type: TOAST_TYPES.INFO,
        title: droppedCustomSlot.Description,
        message: `Item dropped on custom slot "${droppedCustomSlot.Description}"`,
      });
    }

    if (!PlanningHelper.isMediaEpisodeValidForThisChannel(mediaEpisode, selectedChannel)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Media Not Valid For Selected Channel" });
      return;
    }

    //VALIDATE LIVE EVENT DROP HERE
    if (mediaEpisode.IsLive && !(mediaEpisode.AlwaysLive ?? false)) {

      let response = await PlanningHelper.isValidLiveEvent(mediaEpisode, parseInt(start) + offSetTime);
      console.log(response)

      if (response.isValid) {
        checkMediaDealRightsAndAddPlanningItem(mediaEpisode, startDate, selectedChannel, { SID: TX_STATUS.Live, Description: utility.getKeyByValue(TX_STATUS, TX_STATUS.Live) })
      } else {
        if (response.confirmPopup) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
          return;
        }
        checkMediaDealRightsAndAddPlanningItem(mediaEpisode, startDate, selectedChannel)
      }

    } else {
      checkMediaDealRightsAndAddPlanningItem(mediaEpisode, startDate, selectedChannel)
    }

  };


  const checkMediaDealRightsAndAddPlanningItem = (mediaEpisode, startDate, selectedChannel, txStatus) => {
    console.log("Called Check MediaDealRights & Add Planning Item");
    var MediaDealRight = PlanningHelper.getMediaDealRight(
      mediaEpisode,
      startDate,
      selectedChannel
    );

    // here if media rights is more then one then it will return false and the popup to choose the media right
    setLastDroppedItem({ startDate, selectedChannel, mediaEpisode, MediaDealRight });
    if (MediaDealRight == false) {
      setShowPopups({ ...defaultShowPopup, mediaDealRightPopup: true })
    } else {
      addPlanningItem(startDate, selectedChannel, mediaEpisode, MediaDealRight, false, '', 0, null, txStatus);
    }

  }

  const addSelectedMediaDealRight = (dataItem) => {
    if (dataItem.length > 0) {
      const selectedMediaDealRight = dataItem[0];
      addPlanningItem(
        lastDroppedItemRef.current.startDate,
        lastDroppedItemRef.current.selectedChannel,
        lastDroppedItemRef.current.mediaEpisode,
        selectedMediaDealRight
      );
      setLastDroppedItem({});
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_atleast_one_mediadealright_planning_performance_error_message });
    }
  };

  const onCancelPopup = () => {
    setShowPopups(defaultShowPopup);
    setLastDroppedItem({});
  };



  const addSelectedSegment = (dataItem) => {
    if (dataItem.length > 0) {
      const selectedSegment = dataItem[0];
      addPlanningItem(
        lastDroppedItemRef.current.startDate,
        lastDroppedItemRef.current.selectedChannel,
        lastDroppedItemRef.current.mediaEpisode,
        lastDroppedItemRef.current.MediaDealRight,
        false,
        '',
        0,
        selectedSegment._id
      );
      onCancelPopup()
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_atleast_one_mediadealright_planning_performance_error_message });
    }
  };

  const addPlanningItem = async (
    startDate,
    selectedChannel,
    mediaEpisode,
    MediaDealRight,
    fetchSegmentFromDB = false,
    customTitle = '',
    customDuration = 0,
    segment_id = null,
    txStatus = mediaEpisode.IsLive && mediaEpisode.AlwaysLive ? { SID: TX_STATUS.Live, Description: utility.getKeyByValue(TX_STATUS, TX_STATUS.Live) } : { SID: 3, Description: 'Transmission' },
    recursionParentProgramSchedule_id = null
  ) => {

    console.log(segment_id)
    const planningObjectForUI = PlanningHelper.saveScheduleEntity(
      mediaEpisode,
      selectedChannel,
      MediaDealRight,
      startDate,
      offSetTime,
      slotDurationRef.current,
      customTitle,
      customDuration,
      segment_id,
      txStatus,
      recursionParentProgramSchedule_id
    );

    // If dropped on a custom slot, adapt duration and start/slot dates to match the custom slot
    const targetCustomSlot = (startDate && selectedChannel)
      ? PlanningHelper.getMatchingCustomSlot(new Date(startDate.getTime() + offSetTime), null, selectedChannel.SID, customSlots)
      : null;

    if (targetCustomSlot) {
      const slotStart = typeof targetCustomSlot.SlotStart === 'number'
        ? targetCustomSlot.SlotStart
        : new Date(targetCustomSlot.SlotStart).getTime();
      const slotEnd = typeof targetCustomSlot.SlotEnd === 'number'
        ? targetCustomSlot.SlotEnd
        : new Date(targetCustomSlot.SlotEnd).getTime();
      const customSlotDurationMs = slotEnd - slotStart;

      planningObjectForUI.customDuration = customSlotDurationMs;
      planningObjectForUI.ScheduleDate = slotStart;
      planningObjectForUI.SlotDateTime = slotStart;

      // Update StartDate and EndTime so this planning item covers the full custom slot in the scheduler view
      planningObjectForUI.StartDate = new Date(slotStart - offSetTime);
      planningObjectForUI.EndTime = new Date(slotEnd - offSetTime);
      planningObjectForUI.ProgramScheduleSlot = {
        _id: targetCustomSlot._id?.toString() || targetCustomSlot._id,
        Description: targetCustomSlot.Description || ""
      };
    } else {
      planningObjectForUI.ProgramScheduleSlot = null;
    }

    // fetching day part for validation
    const validDayPart = await PlanningHelper.getValidDayPartForTimeBand(planningObjectForUI);

    //CHECK VALID SEGMENT
    if (enableSegmentSelectionPopup && !segment_id && mediaEpisode.segments && mediaEpisode.segments.length > 0) {
      let defaultSegment = mediaEpisode.segments.find((segment) => segment.IsDefault);
      if (defaultSegment) {
        //VALID FOR THIS CHANNEL
        if (defaultSegment.Channels && defaultSegment.Channels.some((x) => x.SID == selectedChannel.SID)) {
          //VALID FOR THIS DAY PART
          if (
            validDayPart &&
            validDayPart.RestrictedPgRating &&
            validDayPart.RestrictedPgRating.some((x) => x._id == defaultSegment.PgRating._id)
          ) {
            setShowPopups({ ...defaultShowPopup, segmentationPopup: true })
            return;
          }
        }
      }
    }

    // Adding Temporarily
    setData([
      ...dataRef.current,
      {
        ...planningObjectForUI,
        SID: planningObjectForUI.Temp_id,
        _id: planningObjectForUI.Temp_id,
        Title: planningObjectForUI.customTitle && planningObjectForUI.customTitle.length > 0 ? planningObjectForUI.customTitle : planningObjectForUI.Title,
        EndTime: planningObjectForUI.customDuration && planningObjectForUI.customDuration > 0 ? new Date(planningObjectForUI.StartDate.getTime() + parseInt(planningObjectForUI.customDuration)) : planningObjectForUI.EndTime
      },
    ]);

    // Now Saving
    var res = await API.savePlanning(
      PlanningHelper.prepareDataforbackendWithSlot({ ...planningObjectForUI }),
      mediaEpisode.segments, false, fetchSegmentFromDB, mediaEpisode.SID, validDayPart
    );

    console.log(mediaEpisode.segments);

    console.log(res);
    if (!res.success) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    } else {
      // NEW LOGIC
      setData(dataRef.current.map((item) => {
        if (item.SID && item.SID == planningObjectForUI.Temp_id) {
          item._id = res.data.header._id;
          item.SID = res.data.header.SID;
          item.Segment_id = res.data.header.Segment_id ?? null;
          item.Style = PlanningHelper.getPlanningColorPreference(item);
          item.Temp_id = undefined;
          item.Formats = res.data.header.Formats;
          item.ProgramScheduleSlot = res.data.header?.ProgramScheduleSlot ?? planningObjectForUI.ProgramScheduleSlot;

          //update actual duration on selcted segmented
          if (res.data.header.Segment_id && mediaEpisode.segments != undefined && mediaEpisode.segments.length > 0) {
            let segment = mediaEpisode.segments.find((seg) => seg._id == res.data.header.Segment_id);
            item.segment = segment;

            if (segment != undefined && props.durationType == "ActualDuration" && !item.customDuration) {
              let actualDuration = segment.ActualDuration;
              const roundOffDur = PlanningHelper.getRoundOffDuration(actualDuration, PlanningHelper.getRoundOffMultiplesBySlotDuration(slotDurationRef.current))
              item.EndTime = new Date(
                item.StartDate.getTime() + roundOffDur
              );
              item.ActualDuration = actualDuration;
            }
          }

          socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_NEW_DROP, module: MODULE.PLANNING, data: item })
          let channel = item.Channel;
          let date = new Date(item.SlotDateTime).setUTCHours(0, 0, 0, 0);
          refreshSchedule(channel, date);

          // Log Capture on Save
          let logData = { event: LOGEVENT.PLANNING_NEW_ADD, module: MODULE.PLANNING, data: item, message: lang.add_new_planning_item_log_message };
          API.SaveProgramScheduleHeaderLogs(logData);

        }
        return item;
      })
      );

      // if media is attached to a deal rright, we will update UI for updated exhibition and repeat
      if (res.data.dealRightHeaders && res.data.dealRightHeaders.length > 0) {
        updateExhibitionAndRepeatOnUI(res.data.dealRightHeaders);
      }

      //UPDATE LIVE EVENT STATUS IF LIVE EVENT DROPPED
      if (mediaEpisode.IsLive) {
        await handlePublishUnPublishLiveEvent({
          programScheduleId: res.data.header._id,
          scheduleMatchDataItem: mediaEpisode,
          slotDateTime: startDate.getTime() + offSetTime,
          channel: selectedChannel,
          publish: true
        })
      }
    }
  };



  const MyCustomPlanningItem = useCallback((props) => {
    return (
      // this component is created with AI if any issue please replace with original CustomPlanningItem // 10 dec 2025, done by rajat and approved by harsh
      <CustomPlanningItemV2
        {...props}
        onPlannerItemSelect={onPlannerItemSelect}
        onPlannerItemDoubleClick={onPlannerItemDoubleClick}
        setFocusedPlanningItemPropRef={setFocusedPlanningItemPropRef}
        lockedPlaylist={lockedPlaylistRef.current}
        itemRenderPreferences={itemRenderPreferences}
      />
    );
  }, [itemRenderPreferences, onPlannerItemDoubleClick]);
  //this function calls when in planner we add delete or added something
  const handleDataChange = useCallback(
    async ({ created, updated, deleted }) => {
      console.log("calling handleDataChange");
      //COMMENTING THIS CODE NOW -- ITEM WILL BE REMOVE FROM UI AND THEN API RESPONSE SHOWS "CANNOT BE DELETE" PLEASE UNCOMMENT IF FACE ANY ISSUE -- DHEERAJ 
      // setData(dataRef.current
      //   .filter(
      //     (item) =>
      //       deleted.find((current) => current._id === item._id) === undefined
      //   )
      //   .map((item) => {
      //     let itemLocal = updated.find((current) => current._id === item._id);

      //     if (itemLocal) {
      //       item = {
      //         ...itemLocal,
      //         ScheduleDate: itemLocal.StartDate.getTime() + offSetTime,
      //         SlotDateTime: itemLocal.StartDate.getTime() + offSetTime,
      //       };
      //     }
      //     return item;
      //   })
      //   .concat(
      //     created.map((item) => ({
      //       ...item,
      //       SID: utility.randomInt(1, 100),
      //       Style: PlanningHelper.getPlanningColorPreference(item),
      //     }))
      //   )
      // );

      //to send to other planniner      
      if (deleted.length > 0) {
        socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_DELETE, module: MODULE.PLANNING, data: deleted })
        let date = new Date(deleted[0].SlotDateTime).setUTCHours(0, 0, 0, 0);
        let channel = deleted[0].Channel;
        refreshSchedule(channel, date);
      }

      //saving in database
      if (updated.length > 0) {
        for (let update of updated) {
          // Start Date and SlotDate Time was not reflecting on edit form on real time. so changing this.

          var swallowCopy = [...dataRef.current];

          if (update.mediaEpisode.IsLive) {

            if (update.mediaEpisode.IsLive && (update.mediaEpisode.AlwaysLive ?? false)) {

              update.TXStatus = { SID: TX_STATUS.Live, Description: utility.getKeyByValue(TX_STATUS, TX_STATUS.Live) }

            }
            else {

              let response = await PlanningHelper.isValidLiveEvent(update.mediaEpisode, update.StartDate.getTime() + offSetTime);

              if (!response.isValid) {
                update.TXStatus = update.TXStatus.SID == TX_STATUS.Live ? { SID: TX_STATUS.Transmission, Description: utility.getKeyByValue(TX_STATUS, TX_STATUS.Transmission) } : update.TXStatus
              } else {
                update.TXStatus = { SID: TX_STATUS.Live, Description: utility.getKeyByValue(TX_STATUS, TX_STATUS.Live) }
              }

            }

          }

          //Since date was not converting so seeting date as milisecond

          let duration = PlanningHelper.getSelectedDurationType(update, props.durationType, slotDurationRef.current);

          const channelSID = update.ChannelSID ?? update.Channel?.SID;
          const selectedChannel = filterChannels.find((c) => c.SID === channelSID) || update.Channel;
          if (selectedChannel) {
            update.Channel = selectedChannel;
            update.ChannelSID = selectedChannel.SID;
          }

          const dropTimeWithOffset = update.StartDate.getTime() + offSetTime;
          const droppedCustomSlot = PlanningHelper.getMatchingCustomSlot(
            new Date(dropTimeWithOffset),
            null,
            channelSID,
            customSlots
          );

          const originalItem = dataRef.current.find(
            (item) => String(item._id) === String(update._id)
          );
          const wasInCustomSlot = Boolean(
            originalItem?.ProgramScheduleSlot && originalItem.ProgramScheduleSlot._id
          );
          const isMovingOutOfCustomSlot = wasInCustomSlot && (
            !droppedCustomSlot ||
            String(droppedCustomSlot._id) !== String(originalItem.ProgramScheduleSlot._id)
          );

          const saveDroppedItem = async (targetCustomSlot, isDetached) => {
            let slotStart = null;
            let slotEnd = null;
            let customSlotDurationMs = null;
            let targetSlotData = null;

            if (targetCustomSlot) {
              ToastNotification({
                type: TOAST_TYPES.INFO,
                title: targetCustomSlot.Description,
                message: `Item dropped on custom slot "${targetCustomSlot.Description}"`,
              });

              slotStart = typeof targetCustomSlot.SlotStart === "number"
                ? targetCustomSlot.SlotStart
                : new Date(targetCustomSlot.SlotStart).getTime();
              slotEnd = typeof targetCustomSlot.SlotEnd === "number"
                ? targetCustomSlot.SlotEnd
                : new Date(targetCustomSlot.SlotEnd).getTime();
              customSlotDurationMs = slotEnd - slotStart;

              targetSlotData = {
                _id: targetCustomSlot._id?.toString() || targetCustomSlot._id,
                Description: targetCustomSlot.Description || ""
              };

              update = {
                ...update,
                customDuration: customSlotDurationMs,
                SlotDateTime: slotStart - offSetTime,
                ScheduleDate: slotStart - offSetTime,
                StartDate: new Date(slotStart - offSetTime),
                EndTime: new Date(slotEnd - offSetTime),
                ProgramScheduleSlot: targetSlotData
              };
            } else {
              targetSlotData = null;
              const resetCustomDur = isDetached ? 0 : update.customDuration;
              update = {
                ...update,
                customDuration: PlanningHelper.autoManagePlanningOverflowDur(
                  PlanningHelper.getSlotTimeBySelectedStartType({ SlotDateTime: update.StartDate.getTime() + offSetTime, ScheduleDate: update.StartDate.getTime() + offSetTime }, props.startType, offSetTime),
                  PlanningHelper.getSlotEndTimeBySelectedStartType({ SlotDateTime: update.StartDate.getTime() + offSetTime, ScheduleDate: update.StartDate.getTime() + offSetTime }, props.startType, offSetTime, duration),
                  offSetTime,
                  resetCustomDur
                ),
                SlotDateTime: update.StartDate.getTime(),
                ScheduleDate: update.StartDate.getTime(),
                ProgramScheduleSlot: null
              };
            }

            console.log(update);
            update_planning(update);
            socket?.emit(SOCKET_EVENTS.onSocketData, { action: SOCKET_ACTION.PLANNING_UPDATE, module: MODULE.PLANNING, data: update })
            let channel = update.Channel;
            let date = new Date(targetCustomSlot ? slotStart : update.SlotDateTime).setUTCHours(0, 0, 0, 0);
            refreshSchedule(channel, date);

            var saveData = {
              _id: update._id,
              SID: update.SID,
              ScheduleDate: targetCustomSlot ? slotStart : update.StartDate.getTime() + offSetTime,
              SlotDateTime: targetCustomSlot ? slotStart : update.StartDate.getTime() + offSetTime,
              MediaDealRight_id: update.MediaDealRight_id,
              Channel: {
                _id: update.Channel?._id,
                SID: update.Channel?.SID,
                FullChannelName: update.Channel?.FullChannelName
              },
              PlanningType: update.PlanningType,
              ExhibitionNumber: update.ExhibitionNumber,
              RepeatNumber: update.RepeatNumber,
              TXStatus: update.TXStatus,
              customDuration: targetCustomSlot ? customSlotDurationMs : update.customDuration,
              ProgramScheduleSlot: targetSlotData
            };
            console.log(update);
            const validDayPart = await PlanningHelper.getValidDayPartForTimeBand(saveData);
            console.log(validDayPart);
            API.savePlanning(saveData, update.mediaEpisode.segments, false, false, 0, validDayPart).then(
              (response) => {
                if (response.success) {
                  // Log Capture on Update

                  if (
                    response.data.dealRightHeaders &&
                    response.data.dealRightHeaders.length > 0
                  )
                    updateExhibitionAndRepeatOnUI(response.data.dealRightHeaders);

                  let logData = { event: LOGEVENT.PLANNING_UPDATE, module: MODULE.PLANNING, data: { ...update, ...saveData }, message: 'Edited using drag drop' };
                  API.SaveProgramScheduleHeaderLogs(logData);
                } else {
                  if (swallowCopy && swallowCopy.length > 0) setData(swallowCopy);
                  ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
                }
              }
            );
          };

          if (isMovingOutOfCustomSlot) {
            const slotName = originalItem?.ProgramScheduleSlot?.Description || "Custom Slot";
            ConfirmAlert(
              () => {
                saveDroppedItem(droppedCustomSlot, true);
              },
              () => {
                setData(dataRef.current.map((item) => ({ ...item })));
              },
              "Detach Slot",
              `Do you want to detach the planning item from this slot (${slotName})?`
            );
          } else {
            await saveDroppedItem(droppedCustomSlot, false);
          }
        }
      }

      if (deleted.length > 0) {
        for (let deleteItem of deleted) {
          var swallowCopy = [...dataRef.current];

          console.log("Deleting");
          API.deletePlanning({
            _id: deleteItem._id,
            MediaDealRight_id: deleteItem.MediaDealRight_id,
          }).then((delresponse) => {
            console.log("delresponse");
            console.log(delresponse);
            if (delresponse.success && delresponse.data) {
              setData(dataRef.current.filter((item) => deleted.find((current) => current._id === item._id) === undefined));

              //UPDATING LIVE EVENT SCHEDULE STATUS
              handlePublishUnPublishLiveEvent({
                scheduleMatchDataItem: deleteItem.mediaEpisode,
                slotDateTime: deleteItem.SlotDateTime,
                publish: false
              });

              if (delresponse.data.dealRightHeaders && delresponse.data.dealRightHeaders.length > 0) {
                updateExhibitionAndRepeatOnUI(delresponse.data.dealRightHeaders);
              }

            } else if (!delresponse.success) {
              if (swallowCopy && swallowCopy.length > 0) setData(swallowCopy);
              ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: delresponse.message });
            }
          });
        }
      }
      console.log(created);
      console.log(updated);
      console.log(deleted);
    },
    [dataRef.current]
  );


  const update_planning = (update) => {
    console.log(update);
    // const newData = [...data];
    // var index = newData.findIndex((item) => item._id == update._id);
    // if (index > 0) {

    //   let duration = PlanningHelper.getSelectedDurationType(newData[index],props.durationType, slotDurationRef.current);
    //   var endDateTime = new Date(update.SlotDateTime + duration),


    //   newData[index] = {
    //     ...newData[index],
    //     IsValid: PlanningHelper.isMediaEpisodeValidForThisChannel(update.mediaEpisode, update.SlotDateTime, update.Channel),
    //     Style: PlanningHelper.getPlanningColorPreference(newData[index]),
    //     SlotDateTime: update.SlotDateTime,
    //     StartDate: new Date(update.SlotDateTime),
    //     EndTime: endDateTime,
    //   };
    //   setData(newData);
    // }

    console.log(update);


    setData(dataRef.current.map((item) => {
      if (item._id == update._id) {

        let duration = PlanningHelper.getSelectedDurationType(update, props.durationType, slotDurationRef.current);
        console.log("Duration");
        console.log(duration);
        console.log(update);

        // fetching realtime as offsetTime variable was not updating, if we change preference hours by not refresh tab
        // i have made it let from const and also created a function to realtime pull preference from local storage to use in update time.
        // this is a rare case but still noticed and handled, by vishal on 24 oct 2024
        const ot = getOffsetTime();

        let updatedItem = {
          ...item,
          ...update,
          IsValid: PlanningHelper.isMediaEpisodeValidForThisChannel(update.mediaEpisode, update.Channel),
          Style: PlanningHelper.getPlanningColorPreference({ ...item, ...update }),
          Segment_id: update.Segment_id,
          SlotDateTime: update.SlotDateTime + ot,
          ScheduleDate: update.ScheduleDate != null ? update.ScheduleDate + ot : item.ScheduleDate,
          StartDate: update.StartDate || PlanningHelper.getSlotTimeBySelectedStartType({ ...update, SlotDateTime: update.SlotDateTime + ot, ScheduleDate: update.ScheduleDate + ot }, props.startType, ot),
          EndTime: update.EndTime || PlanningHelper.getSlotEndTimeBySelectedStartType({ ...update, SlotDateTime: update.SlotDateTime + ot, ScheduleDate: update.ScheduleDate + ot }, props.startType, ot, duration),
          ActualDuration: update.ActualDuration,
          NominalDuration: update.NominalDuration,
          TXStatus: update.TXStatus,
          customDuration: update.customDuration,
          ProgramScheduleSlot: update.ProgramScheduleSlot !== undefined ? update.ProgramScheduleSlot : item.ProgramScheduleSlot
        };

        console.log(updatedItem);
        return updatedItem

      }
      else {
        return item;
      }
    })
    );



  }

  const updateExhibitionAndRepeatOnUI = (updatedHeaders) => {
    setData(dataRef.current.map((item) => {
      const dealrightUpdatedHeader = updatedHeaders.find(
        (x) => item && item._id && x._id.toString() == item._id.toString()
      );
      if (dealrightUpdatedHeader) {
        item.ExhibitionNumber = dealrightUpdatedHeader.ExhibitionNumber;
        item.RepeatNumber = dealrightUpdatedHeader.RepeatNumber;
        item.PlanningType = dealrightUpdatedHeader.PlanningType;
        item.Style = PlanningHelper.getPlanningColorPreference(item);
        item.InvalidReason = PlanningHelper.getInvalidReason(item);
      }
      return item;
    })
    );
  };

  const onUpdateSynopsis = async () => {

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      SlotSynopsis: synopsisRef.current
    });

    setShowPopups(defaultShowPopup)

    if (updateRes.success) {
      refreshPlanning();

      var updatedData = { ...focusedPlanningItemPropRef.current.dataItem, OldSlotSynopsis: focusedPlanningItemPropRef.current.dataItem.SlotSynopsis, UpdatedSlotSynopsis: synopsisRef.current };
      let logData = { event: LOGEVENT.UPDATE_PLANNING_SYNOPSIS, module: MODULE.PLANNING, data: updatedData, message: LOGEVENT.UPDATE_PLANNING_SYNOPSIS };
      API.SaveProgramScheduleHeaderLogs(logData);
    }



  }

  const onUpdateTxStatus = async () => {

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please select a slot to update TX status" });
      return;
    }

    let updateStatusData = [];

    for (let i = 0; i < plannerSelectedItemsRef.current.length; i++) {
      const element = plannerSelectedItemsRef.current[i];
      let focusedMediaEpisode = element;

      if (focusedMediaEpisode.mediaEpisode.IsLive && focusedMediaEpisode.mediaEpisode.AlwaysLive && txStatus.SID != TX_STATUS.Live) {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `Media is set as always live, cannot change TX status to ${txStatus.Description}` });
        return;
      }

      if (!focusedMediaEpisode.mediaEpisode.AlwaysLive && focusedMediaEpisode.mediaEpisode.IsLive && txStatus.SID == TX_STATUS.Live) {
        let response = await PlanningHelper.isValidLiveEvent(focusedMediaEpisode.mediaEpisode, focusedMediaEpisode.SlotDateTime);

        //VALIDATION
        if (!response.isValid) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
          return;
        }
      }

      // this validation is applied in planning and scheduling, please make sure you change at both places for any code change
      if (!focusedMediaEpisode.mediaEpisode.AlwaysLive && (txStatusRef.current.SID == TX_STATUS.Live || txStatusRef.current.SID == TX_STATUS.SDD)) {
        var response = await API.canChangeTxStatusToLiveOrDalayed(focusedMediaEpisode.SlotDateTime, focusedMediaEpisode.MediaEpisode_id);

        if (!response.success) {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
          return;
        }
      }

      updateStatusData.push({
        _id: focusedMediaEpisode._id,
        TXStatus: { SID: txStatusRef.current.SID, Description: txStatusRef.current.Description }
      });
    }

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, updateStatusData);
    setShowPopups(defaultShowPopup)

    if (updateRes.success) {
      refreshPlanning();

      updateRes.data.map((item, i) => {
        var updatedData = { ...plannerSelectedItemsRef.current[i], OldTxStatus: plannerSelectedItemsRef.current[i]?.TXStatus, UpdatedTxStatus: { SID: txStatusRef.current.SID, Description: txStatusRef.current.Description } };
        let logData = { event: LOGEVENT.UPDATE_PLANNING_TX_STATUS, module: MODULE.PLANNING, data: updatedData, message: LOGEVENT.UPDATE_PLANNING_TX_STATUS };
        API.SaveProgramScheduleHeaderLogs(logData);
      })
    }

  }

  const onClearCustomDuration = async () => {
    if (!focusedPlanningItemPropRef.current.dataItem.customDuration) {
      ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: 'Custom duration not set' });
      return;
    }
    let res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      customDuration: null
    });
    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Slot duration updated successfully' });
      refreshPlanning();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onMarkChangeFlag = async (isChanged = true) => {

    let res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      isChanged: isChanged
    });

    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Change flag updated successfully' });
      refreshPlanning();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  }

  const onEditCustomSlotDuration = async () => {
    const customDurationMs = utility.convertStringWithFramesToMilliseconds(customSlotDuration);
    const maxCustomDurationMs = 12 * 60 * 60 * 1000;

    if (!customSlotDuration ||
      customSlotDuration.trim() === "" ||
      customSlotDuration === "00:00:00:00" ||
      !Number.isFinite(customDurationMs) ||
      customDurationMs == 0 ||
      customDurationMs < 5 * 60 * 1000 ||
      customDurationMs > maxCustomDurationMs
    ) {
      ToastNotification({
        type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title,
        message: customDurationMs > maxCustomDurationMs
          ? "Custom duration cannot exceed 12 hours"
          : customDurationMs < 5 * 60 * 1000
            ? lang.please_enter_custom_duration_min_time_error_message
            : lang.please_enter_custom_duration_error_message
      });
      return;
    }

    //IsFormPasteStrand
    if (isPasteStrandWithCD) {

      const res = await onPasteStrand(true);

      console.log(res)

      setShowPopups(defaultShowPopup);

    } else {

      const saveData = plannerSelectedItemsRef.current.map((item) => {
        return {
          _id: item._id,
          customDuration: customDurationMs
        }
      })

      let res = await API.saveData(ENTITYNAME.ProgramSchedule, saveData);
      if (res.success) {
        ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: 'Slot duration updated successfully' });
        refreshPlanning();
      } else {
        ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
      }

      setShowPopups(defaultShowPopup);

    }


  }

  const handleSetImportant = async (isImportant = false) => {
    let res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      isImportant: isImportant
    });
    console.log(res);

    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: lang.important_update_successfully_message });
      refreshPlanning();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }
  }

  const onUpdateProgramScheduleRouterCommand = async () => {

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      RouterCommand: routerCommandRef.current
    });

    setShowPopups(defaultShowPopup);

    if (updateRes.success) {
      refreshPlanning();

      var updatedData = { ...focusedPlanningItemPropRef.current.dataItem, OldComment: focusedPlanningItemPropRef.current?.dataItem?.RouterCommand ?? "", UpdatedComment: routerCommandRef.current };
      let logData = { event: LOGEVENT.PLANNING_ADD_ROUTER_COMMAND, module: MODULE.PLANNING, data: updatedData, message: LOGEVENT.PLANNING_UPDATE_ROUTER_COMMAND };
      API.SaveProgramScheduleHeaderLogs(logData);
    }

  }

  const onUpdateProgramScheduleComment = async () => {

    var updateRes = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      Comment: commentRef.current
    });

    setShowPopups(defaultShowPopup);

    if (updateRes.success) {
      refreshPlanning();

      var updatedData = { ...focusedPlanningItemPropRef.current.dataItem, OldComment: focusedPlanningItemPropRef.current?.dataItem?.Comment ?? "", UpdatedComment: commentRef.current };
      let logData = { event: LOGEVENT.PLANNING_ADD_COMMENT, module: MODULE.PLANNING, data: updatedData, message: LOGEVENT.PLANNING_UPDATE_COMMENT };
      API.SaveProgramScheduleHeaderLogs(logData);
    }

  }

  const onChangeSynopsis = (e) => {
    setSynopsisRef(e.target.value);
    // console.log(synopsisRef)
  }

  const loadSavedFastSegments = () => {
    console.log('here planning main');
    refreshPlanning();
  }

  const onInsertDummy = (e) => {
    if (e && e.target && e.target.localName == "input") {
      return;
    }

    console.log(selectedSlotRef.current);
    if (selectedSlotRef.current.SlotDateTime == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_area_on_planner_to_insert_dummy_planning_performance_error_message });
      return;
    }

    setShowPopups({ ...defaultShowPopup, insertDummyPopup: true })
  }

  const onEditDummy = () => {

    if (!focusedPlanningItemPropRef.current.dataItem.mediaEpisode.IsDummy) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: `This is not a dummy media` });
      return;
    }

    setShowPopups({ ...defaultShowPopup, editDummyPopup: true })
  }



  //programe replacement
  //----real time upated pending
  const replaceProgram = async (newMediaEpisode, mediaDealRight_id = null) => {

    if (newMediaEpisode == undefined || newMediaEpisode._id == undefined) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.replacement_media_lost_error_message });
    }

    const saveData = {
      SID: 0,
      Channel: focusedPlanningItemPropRef.current.dataItem.Channel,
      MediaEpisode_id: newMediaEpisode._id,
      ScheduleDate: focusedPlanningItemPropRef.current.dataItem.SlotDateTime,
      SlotDateTime: focusedPlanningItemPropRef.current.dataItem.SlotDateTime,
      Segment_id: null,
      ParentProgramSchedule_id: null,
      IsValid: true,
      MediaDealRight_id: mediaDealRight_id,
    };

    var response = await API.ReplaceProgram(saveData, focusedPlanningItemPropRef.current.dataItem); // true for loadchildren
    console.log(response);

    if (response.success) {

      //add
      const planningObjectForUI = PlanningHelper.saveScheduleEntity(
        newMediaEpisode,
        focusedPlanningItemPropRef.current.dataItem.Channel,
        null,
        new Date(focusedPlanningItemPropRef.current.dataItem.SlotDateTime - offSetTime), // we will reduce offset time instead
        0, // for replacement we will send 0 as offset time
        slotDurationRef.current,
        '',
        0
      );

      //real time ui temp add and delete existing
      setData(dataRef.current.map((data) => {
        if (data._id == focusedPlanningItemPropRef.current.dataItem._id) {

          console.log('here');
          return {
            ...planningObjectForUI,
            SID: planningObjectForUI.Temp_id,
            _id: planningObjectForUI.Temp_id,
            Title: planningObjectForUI.customTitle && planningObjectForUI.customTitle.length > 0 ? planningObjectForUI.customTitle : planningObjectForUI.Title,
            EndTime: planningObjectForUI.customDuration && planningObjectForUI.customDuration > 0 ? new Date(planningObjectForUI.StartDate.getTime() + parseInt(planningObjectForUI.customDuration)) : planningObjectForUI.EndTime
          }
        } else {
          return data;
        }
      })
      );

      let channel = focusedPlanningItemPropRef.current.dataItem.Channel;
      let date = new Date(focusedPlanningItemPropRef.current.dataItem.SlotDateTime).setUTCHours(0, 0, 0, 0);
      refreshSchedule(channel, date);

      if (focusedPlanningItemPropRef.current?.dataItem?.ActualDuration < newMediaEpisode?.Duration) {
        ToastNotification({ type: TOAST_TYPES.INFO, title: lang.info_message_title, message: `The current media duration is ${utility.convertMilisecondsToStringWithFrames(focusedPlanningItemPropRef.current.dataItem?.mediaEpisode?.Duration, false)}, and you are changing it to a new media with a duration of ${utility.convertMilisecondsToStringWithFrames(newMediaEpisode.Duration, false)}.` });
      }

      let logData = { event: LOGEVENT.PROGRAM_REPLACEMENT, data: focusedPlanningItemPropRef.current.dataItem, message: LOGEVENT.PROGRAM_REPLACEMENT, module: MODULE.PLANNING };
      API.SaveProgramScheduleHeaderLogs(logData);

    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: response.message });
    }
  }

  const programReplacement = async (replaceDataItem) => {

    if (focusedPlanningItemPropRef.current.dataItem == {}) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_planning_item_planning_wrapper_error_message });
      return;
    }

    if (replaceDataItem.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_one_program_to_replace_with_error_message });
      return;
    }
    var mediaEpisode = replaceDataItem[0];

    // checking rights
    const dealRights = await PlanningHelper.getMediaEpisodeDealRights(mediaEpisode);

    if (!PlanningHelper.isMediaEpisodeValidForThisChannel({ ...mediaEpisode, MediaDealRights: dealRights }, focusedPlanningItemPropRef.current.dataItem.Channel)) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.media_not_valid_for_selected_channel_error_message });
      return;
    }

    var validMediaDealRight = PlanningHelper.getMediaDealRight(
      { ...mediaEpisode, MediaDealRights: dealRights },
      focusedPlanningItemPropRef.current.dataItem.SlotDateTime,
      focusedPlanningItemPropRef.current.dataItem.Channel
    );

    // here if media rights is more then one then it will return false and the popup to choose the media right
    if (validMediaDealRight == false) {
      setProgramToReplace(mediaEpisode);
      setShowPopups({ ...defaultShowPopup, mediaDealRightPopup: true })
    } else {
      replaceProgram(mediaEpisode);
    }

  };

  const handleAttachMediaToSlot = async (selectedMediaList) => {
    if (!selectedMediaList || selectedMediaList.length === 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.select_one_program_to_replace_with_error_message || "Please select a media item" });
      return;
    }

    const slot = selectedSlotForAttachRef.current || selectedSlotForAttach || clickedCustomSlotRef.current || clickedCustomSlot;
    if (!slot) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "No custom slot selected" });
      return;
    }

    const mediaEpisode = selectedMediaList[0];
    setShowPopups(defaultShowPopup);

    const res = await API.attachMediaToSlot({
      media: mediaEpisode,
      slot: slot
    });

    if (res && res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res.message || "Media attached to slot successfully" });
      refreshPlanning();
      if (slot.Channel) {
        const channel = slot.Channel;
        const slotStart = typeof slot.SlotStart === 'number' ? slot.SlotStart : (typeof slot.SlotDateTime === 'number' ? slot.SlotDateTime : new Date(slot.SlotDateTime).getTime());
        const date = new Date(slotStart).setUTCHours(0, 0, 0, 0);
        refreshSchedule(channel, date);
      }
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res?.message || "Failed to attach media to slot" });
    }
  };

  //INSERT PROGRAM GROUP
  const onInsertProgramGroup = (e) => {
    if (e && e.target && e.target.localName == "input") {
      return;
    }

    if (selectedSlotRef.current.SlotDateTime == null) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: lang.please_select_area_on_planner_to_insert_program_group_planning_performance_error_message });
      return;
    }

    setShowPopups({ ...defaultShowPopup, insertProgramGroup: true })
  }


  const onRemoveStartAndEndCredits = async (creditTypeToRemove) => {

    if (plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: 'Please first select planning item' });
      return;
    }

    const msg = creditTypeToRemove == SEGMENT_DETAILS_CREDIT_TYPE.Both ? "Start and End Credits" : (creditTypeToRemove == SEGMENT_DETAILS_CREDIT_TYPE.EndCredit ? "End Credits" : "Start Credits")

    ConfirmAlert(
      async () => {
        var updateRes = await API.RemoveStartAndEndCredits({
          ProgramSchedule_ids: plannerSelectedItemsRef.current.map(x => x._id),
          ExcludeCreditsType: creditTypeToRemove
        });

        if (updateRes?.success) {
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: updateRes.message });
        }
        else
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: updateRes.message });
      }, // on Click yes
      async () => {
        // on click no
      },
      `Remove ${msg} ?`, //title
      `This will delete ${msg} segments from schedule. Do you want to proceed ?` // message
    );


  }


  const customTimeHeaderCell_Old = (props) => {
    // debugger
    let startMilisecond = offSetHours * 3600000;
    let date = new Date(props.date.getTime() + startMilisecond);
    let hours = date.getUTCHours();
    let min = date.getUTCMinutes();
    hours = hours >= 24 ? hours - 24 : hours;
    let timeString = String(hours).padStart(2, "0") + ":" + String(min).padStart(2, "0");

    return (
      <TimeHeaderCell
        {...props}
        format={timeString}
      />
    );
  }

  const customTimeHeaderCell = (props) => {
    const startMilisecond = offSetHours * 3600000;
    const utcDate = new Date(props.date.getTime() + startMilisecond);

    const utcHours = utcDate.getUTCHours();
    const utcMinutes = utcDate.getUTCMinutes();
    const utcTimeString = `${String(utcHours).padStart(2, "0")}:${String(utcMinutes).padStart(2, "0")}`;

    //GET ADDITIONAL TIME ZONE VALUE
    let preferenceData = utility.getValue(LOCALSTORAGE_KEY.planningpreference);
    const additionTimeZone = PlanningHelper.getAdditionalTimeZone(filterChannels);
    const mainTimeZone = PlanningHelper.getMainTimeZone(filterChannels);

    let additionalTimeZoneString = "";
    const enableAdditionalTimeZone = additionTimeZone?.EnableAdditionalTimeZone ?? false;
    if (enableAdditionalTimeZone) {


      additionalTimeZoneString = utility.getTimeByTimeZoneV2(
        utcTimeString,
        mainTimeZone,
        additionTimeZone?.AdditionalTimeZone,
        additionTimeZone?.AdditionalTimeZone?.Label,
      );

    }

    return (
      <div
        date={props.date}
        className="k-scheduler-cell k-heading-cell k-side-cell k-major-cell"
        style={{
          minWidth: "61.2188px",
          whiteSpace: "normal", // allow wrapping
          overflow: "visible", // allow overflow to show
          display: "flex",
          flexDirection: "column",
          padding: "0px 8px",
          fontSize: "15px",
          lineHeight: "1.3",
          textAlign: "right"
        }}
      >
        {mainTimeZone && mainTimeZone.Label ? <div style={{ fontSize: "12px", color: "#666" }}>{`${utcTimeString} ${mainTimeZone?.Label}`}</div> : <div>{utcTimeString}</div>}
        {enableAdditionalTimeZone && <div style={{ fontSize: "10px", color: "#666" }}>{additionalTimeZoneString}</div>}
      </div>
    );
  };


  // to activate weekday range
  // const weekDayRangeChange = (e) => {
  //   if (e.target.name === "start" && e.target.value.ID > weekDayRange.end.ID) {
  // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Start day should be less than end day"});
  //   }
  //   else if (e.target.name === "end" && e.target.value.ID < weekDayRange.start.ID) {
  // ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "End day should be greater than start day"});
  //   }
  //   else {
  //     setWeekDayRange({
  //       ...weekDayRange,
  //       [e.target.name]: e.target.value
  //     })
  //   }
  // }

  //scheduler header
  const header = (props) => {
    return (
      <SchedulerHeader>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
          {/* today */}
          {props.children[0]}
          {/* calendar */}
          {/* {props.children[1]} */}
          {/* slot duratioon */}
          <div style={{ position: "relative", top: "-3px" }}>
            {lang.slot_duration_title_label + ':'}

            <DropDownList
              value={slotDuration + " min"}
              style={{
                width: "100px",
                marginLeft: "20px",
              }}
              data={SLOT_TIMES}
              onChange={(e) => {
                startTransition(() => {
                  // setData([]);
                  setSlotDuration(e.value);
                  resetPlanningGridHeight();
                  // accordingly find index of suitable slot division
                  const index = SLOT_TIMES.indexOf(e.value);
                  setSlotDivision(slotDivisions[index]);

                  //SET 
                  utility.setSessionValue(LOCALSTORAGE_KEY.SELECTED_PLANNING_SLOT_DURATION, e.value);
                  // refreshPlanning()
                  localPlanningUIRefresh()
                });
              }}
            />
            {/* ZOOM */}
            <label style={{ marginLeft: "60px" }}>Zoom:</label>
            <Slider
              style={{ position: "relative", top: "9px" }}
              buttons={false}
              value={slotDivision}
              step={1}
              min={1}
              max={6}
              onChange={(e) => {
                setSlotDivision(Math.round(e.value));
              }}
            >
              {/* {Array.from({ length: 6 }, (_, i) => i + 1).map((value, index) => (
                <SliderLabel position={index + 1}>
                  {value}
                </SliderLabel>
              ))} */}
            </Slider>
          </div>
          {/*  to activate weekday range */}
          {/* {view == "week" && <> <div>
            Start Week Day
            <DropDownList
              name="start"
              data={MyDays}
              textField="Name"
              value={weekDayRange.start}
              onChange={weekDayRangeChange}
              style={{ width: "auto" }}
            />
          </div>
            <div>
              End Week Day
              <DropDownList
                name="end"
                data={MyDays}
                textField="Name"
                value={weekDayRange.end}
                onChange={weekDayRangeChange}
                style={{ width: "auto" }}
              />
            </div>
          </>
          } */}
          {/* week day */}
          {props.children[3]}
        </div>
      </SchedulerHeader>
    );
  };


  const onMarkAsCatchUp = async (IsCatchUp = false) => {
    let res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      IsCatchUp: IsCatchUp
    });

    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: IsCatchUp ? 'Mark as catch up successfully' : 'Un-Mark as catch up successfully' });
      refreshPlanning();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  }


  const onUpdateL2VEvent = async () => {

    if (!plannerSelectedItemsRef.current || plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please Select Atleast One Event" });
      return;
    }

    if ((plannerSelectedItemsRef.current.some((item) => !item?.IsCatchUp))) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "All Event must be as CatchUp Event" });
      return;
    }
    console.log(plannerSelectedItemsRef.current);

    let res = await API.updateL2VEvent(plannerSelectedItemsRef.current.map(item => {
      return {
        _id: item._id,
        SlotDateTime: item.SlotDateTime,
        Channel: item.Channel,
      }
    }));
    console.log(res);

    if (res.success) {
      setPublishResults(res?.data);
      setShowPublishToVodResultPopup(true);
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: "Publish to VOD Successfull" });
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  }

  const onAssignNewTransmissionID = async () => {

    if (!plannerSelectedItemsRef.current || plannerSelectedItemsRef.current.length == 0) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "Please Select Atleast One Event" });
      return;
    }

    const programScheduleIds = plannerSelectedItemsRef.current.map(item => item._id);

    let res = null
    ConfirmAlert(
      async () => {
        res = await API.assignNewTransmissionIds(programScheduleIds);

        if (res.success) {
          ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: res?.message });
          let selectedItems = [...plannerSelectedItemsRef.current]
          refreshPlanning();
          setAssignNewTransmissionIdPopup({ show: true, selectedItems: selectedItems, updatedData: res?.data || [] });
        } else {
          ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
        }
      }, // on Click yes
      null, // on click no
      lang.assingn_new_transmissionid_confirmation_message, //title
      lang.assingn_new_transmissionid_confirmation_description
    );

  }

  const onMarkAsBlackOut = async (IsBlackOut = false) => {
    let res = await API.saveData(ENTITYNAME.ProgramSchedule, {
      _id: focusedPlanningItemPropRef.current.dataItem._id,
      IsBlackOut: IsBlackOut
    });

    if (res.success) {
      ToastNotification({ type: TOAST_TYPES.SUCCESS, title: lang.success_message_title, message: IsBlackOut ? 'Mark as Blackout successfully' : 'Un-Mark as Blackout successfully' });
      refreshPlanning();
    } else {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: res.message });
    }

  }

  const getUtcDisplayDate = (utcMs) => {
    if (utcMs === null || utcMs === undefined || Number.isNaN(Number(utcMs))) {
      return null;
    }

    const utcDate = new Date(Number(utcMs));
    return new Date(utcDate.getTime() + utcDate.getTimezoneOffset() * 60000);
  };

  const setCustomSlotEndTimePickerDate = () => {
    const item = plannerSelectedItemsRef.current[0];
    if (!item) {
      setCustomSlotEndTime(null);
      return;
    }

    const durationMs = Number(item?.customDuration ?? item?.mediaEpisode?.Duration ?? 0);
    const endUtcMs = Number(item?.SlotDateTime ?? 0) + durationMs;

    setCustomSlotEndTime(getUtcDisplayDate(endUtcMs));
  }

  const handleCustomDurationChange = (e) => {
    const durationValue = e.target.value;

    setCustomSlotDuration(durationValue);

    const item = plannerSelectedItemsRef.current?.[0];
    if (!item) return;

    const durationMs = utility.convertStringWithFramesToMilliseconds(durationValue);
    if (!Number.isFinite(durationMs)) return;

    const endUtcMs = Number(item?.SlotDateTime ?? 0) + durationMs;
    setCustomSlotEndTime(getUtcDisplayDate(endUtcMs));
  };

  const handleCustomEndTimeChange = (e) => {
    const selectedDate = e.value;
    if (!selectedDate) return;

    setCustomSlotEndTime(selectedDate);

    const selectedMs = utility.getLocalDateTimeToUtcMiliseconds(selectedDate);
    const startMs = Number(plannerSelectedItemsRef.current?.[0]?.SlotDateTime ?? 0);

    if (selectedMs < startMs) {
      ToastNotification({ type: TOAST_TYPES.ERROR, title: lang.invalid_error_message_title, message: "End time must be greater than start time" });
      return;
    }

    const diffMs = selectedMs - startMs;
    const duration = moment.duration(diffMs);
    const formattedDuration =
      `${String(Math.floor(duration.asHours())).padStart(2, "0")}:` +
      `${String(duration.minutes()).padStart(2, "0")}:` +
      `${String(duration.seconds()).padStart(2, "0")}:00`;
    setCustomSlotDuration(formattedDuration);
  };

  return (
    <>
      <Scheduler
        id="PlannerID"
        data={displayData}
        date={date}
        onDateChange={onDateChange}
        editable={{
          select: true,
          remove: true,
          drag: true,
          resize: false,
          add: false,
          edit: false,
        }}
        timezone="Etc/UTC"
        form={CustomFormWithAdditionalProps}
        defaultView={view}
        view={view}
        item={MyCustomPlanningItem}
        modelFields={customModelFields}
        footer={() => <></>}
        ref={MyScheduler}
        resources={resources}
        group={group}
        header={(props) => header(props)}
        viewSlot={CustomViewSlot}
        onDataChange={handleDataChange}
        onViewChange={(props) => {
          if (props.value == "day") {
            setShowPopups({ ...defaultShowPopup, showCustomDatesPopup: true });
            return;
          }
          setViewData(props.value);
          refreshPlanning();
        }}
        style={{ overflowX: "auto" }}
      >
        {/* week view to only have monday wednesday nd friday*/}
        <WeekView
          title="Week"
          // to activate weekday range
          dateRange={{
            // get neareset monday near to the date
            start: moment(date).utc().startOf("week").add(weekStartDay._id, "days").toDate(),
            end: moment(date).utc().endOf("week").add(weekStartDay._id, "days").toDate(),
            // start: moment(date).utc().startOf("week").add(Day.Monday, "days").toDate(),
            // end: moment(date).utc().startOf("week").add(Day.Sunday, "days").toDate(),
            // zonedStart: moment(date).utc().startOf("week").add(Day.Monday, "days").toDate(),
            // zonedEnd: moment(date).utc().startOf("week").add(Day.Sunday, "days").toDate(),
          }}
          style={{ width: "fit-content" }}
          dateHeaderCell={(pro) => <DateHeaderCell {...pro} style={{ ...pro.style, backgroundColor: (pro.children._owner?.index ?? 0) > 4 ? weekStartDay?.bgColor ?? "white" : "white" }} format={'d-MMM-yy, E'} />}
          timeHeaderCell={customTimeHeaderCell}
          slotDivisions={slotDivision}
          slotDuration={slotDuration}
          showWorkHours={false}
          startTime={primeStartTime}
          endTime={primeEndTime}
          viewItem={SchedulerProportionalViewItem}
        />
        {/* day view */}
        <WorkWeekView
          title={'Day'}
          dateRange={{
            start: moment(date).utc().startOf("day").toDate(),
            end: moment(date).utc().endOf("day").toDate(),
            zonedStart: moment(date).utc().startOf("day").toDate(),
            zonedEnd: moment(date).utc().endOf("day").toDate(),
          }}
          numberOfDays={1}
          style={{ width: "fit-content" }}
          dateHeaderCell={(pro) => <DateHeaderCell {...pro} format={'d-MMM-yy, E'} />}
          timeHeaderCell={customTimeHeaderCell}
          slotDivisions={slotDivision}
          slotDuration={slotDuration}
          showWorkHours={false}
          startTime={primeStartTime}
          endTime={primeEndTime}
          viewItem={SchedulerProportionalViewItem}
        />
        {/* Month View */}
        {/* <DayView
          title="Custom"
          dateRange={{
            start: moment(new Date(customDates.startDate)).utc().toDate(),
            end: moment(new Date(customDates.endDate)).add(1, "days").utc().toDate(),
            zonedStart: moment(new Date(customDates.startDate)).utc().toDate(),
            zonedEnd: moment(new Date(customDates.endDate)).add(1, "days").utc().toDate(),
          }}
          numberOfDays={(new Date(customDates.endDate) - new Date(customDates.startDate)) / (24 * 60 * 60 * 1000)}
          style={{ width: "fit-content" }}
          timeHeaderCell={customTimeHeaderCell}
          slotDivisions={slotDivision}
          slotDuration={slotDuration}
          showWorkHours={false}
          startTime={primeStartTime}
          endTime={primeEndTime}
        /> */}
      </Scheduler>

      <ContextMenu model={plannerBlankAreaMenuModel} ref={refForBlankArea} />
      <ContextMenu
        // Commented for now subMenu is not opening
        // style={{ maxHeight: 'calc(100vh - 0px)', overflowY: 'auto', msOverflowStyle: 'none', scrollbarWidth: 'none' }} 

        //ADD ALL OPTION TO SHORT MENU AS WELL
        model={enableShortPlanningMenu ? plannerOnItemMenuModelShort : plannerOnItemMenuModel} ref={refForItem} />

      {showPopups.mediaDealRightPopup && (

        <div className="row" style={{ marginLeft: "-02px", width: "570px" }}>
          <div className="col-12">
            <CollectionSelection
              title={
                lang.please_choose_one_publishing_rights_collection_header
              }
              entityname={ENTITYNAME.MediaDealRights}
              //SEND CUSTOM COLUMNS TO THIS
              customColumns={MediaDealRights_columns}
              wherestatement={[[
                "media_id",
                "=",
                lastDroppedItemRef.current.mediaEpisode._id,
              ], ["PlatformType.SID", '=', PLATFORMTYPE[0].SID]]} // 0 indes is Linear
              setDataList={addSelectedMediaDealRight}
              mode={"single"}
              closeForm={onCancelPopup}
            />
          </div>
        </div>

      )}

      {showPopups.segmentationPopup && (

        <div className="row" style={{ marginLeft: "-02px", width: "570px" }}>
          <div className="col-12">
            <CollectionSelection
              title={
                lang.please_select_segment_header
              }
              data
              entityname={ENTITYNAME.MediaEpisodeSegment}
              //SEND CUSTOM COLUMNS TO THIS
              customColumns={MediaEpisodeSegment_columns}
              // wherestatement={["MediaEpisodeSID", "=", lastDroppedItemRef.current.mediaEpisode.SID]}
              wherestatement={[
                ["MediaEpisodeSID", "=", lastDroppedItemRef.current.mediaEpisode.SID],
                ["Channels.SID", "in", filterChannels.map((x) => x.SID)],
              ]}

              setDataList={addSelectedSegment}
              mode={"single"}
              closeForm={onCancelPopup}
              note={"* Segments valid for this channel only"}
            />
          </div>
        </div>

      )}

      {showPopups.updateSynopsis && (
        <BossDialog
          title={lang.update_synopsis}
          width={"500px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group">
                <label htmlFor="TabView">{lang.synopsis_label}</label>
              </div>
              <div className="col-12 form-group">
                <textarea className="pl-2"
                  type="text"
                  // value={synopsisRef.current}
                  style={{ border: 'solid lightgrey 1px', height: '100px', width: '450px' }}
                  onChange={onChangeSynopsis}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateSynopsis} onCancel={() => setShowPopups(defaultShowPopup)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {showPopups.fastSegmentation && <MediaFastSegmentationPopup mediaEpisodeEntity={focusedPlanningItemPropRef.current.dataItem.mediaEpisode} programScheduleEntity={focusedPlanningItemPropRef.current.dataItem} refreshSegments={loadSavedFastSegments} onClose={() => setShowPopups(defaultShowPopup)} source={'planning'} />}

      {showPopups.insertDummyPopup && <PlanningInsertDummyPopup
        isRightClick={true}
        selectedSlot={selectedSlotRef.current}
        addPlanningItem={addPlanningItem}
        getSelectedChannel={getSelectedChannel}
        onClose={() => { setShowPopups(defaultShowPopup) }}
      />}

      {showPopups.editDummyPopup && <PlanningEditDummyPopup selectedPlanningItem={focusedPlanningItemPropRef.current.dataItem} onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm} getSelectedChannel={getSelectedChannel} onClose={() => setShowPopups(defaultShowPopup)} />}

      {showPopups.insertProgramGroup && <PlanningInsertProgramGroup selectedSlotDateTime={selectedSlotRef.current.SlotDateTime.getTime()} channel={filterChannels[selectedSlotRef.current.channelIndex]} onClose={() => setShowPopups(defaultShowPopup)} offSetTime={offSetTime} refreshPlanning={refreshPlanning} setStatusMsg={setStatusMsg} />}

      {showPopups.programReplacement && (<>
        <ContractCollectionSelection
          title={`${lang.select_program_to_replace_with_collection_title}`}
          entityname={ENTITYNAME.MediaEpisode}
          wherestatement={["MediaCategory.isLong", "=", true]}
          setDataList={programReplacement}
          hideSeriesSeason={true}
          mode={"single"}
          closeForm={() => setShowPopups(defaultShowPopup)}
          width={"50vw"} />
      </>
      )}

      {showPopups.attachMediaToSlot && (
        <ContractCollectionSelection
          title="Attach media to slot"
          entityname={ENTITYNAME.MediaEpisode}
          wherestatement={["MediaCategory.isLong", "=", true]}
          setDataList={handleAttachMediaToSlot}
          hideSeriesSeason={true}
          mode={"single"}
          closeForm={() => setShowPopups(defaultShowPopup)}
          width={"50vw"}
        />
      )}


      {showPopups.updateTXStatus && (
        <BossDialog
          title={lang.update_txstatus_actionbutton_menutext}
          width={"300px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group">
                <label htmlFor="TabView">{lang.tx_status_label}</label>
                <DropDownList
                  style={{ backgroundColor: "white" }}
                  data={txStatusData}
                  name="txStatus"
                  textField="Description"
                  dataItemKey="SID"
                  value={txStatus}
                  onChange={(e) => { setTxStatus(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateTxStatus} onCancel={() => setShowPopups(defaultShowPopup)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {showPopups.showEditSlotDurationPopup && (
        <BossDialog
          title={'Set Custom Duration'}
          width={"380px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <EditPageHeader title={""} onSubmit={onEditCustomSlotDuration} onCancel={() => setShowPopups(defaultShowPopup)} showTitle={false} />

            <div className="form-group">
              <label htmlFor="">{lang.duration_label} *</label>
              <TimePickerWithFormat
                name="Duration"
                value={customSlotDuration}
                onChange={handleCustomDurationChange}
                required
              />
              {plannerSelectedItemsRef.current.length == 1 && <>
                <label htmlFor="">{lang.end_time_label} *</label>
                <DateTimePicker
                  name="EndTime"
                  value={customSlotEndTime}
                  format="yyyy-MM-dd HH:mm:ss"
                  steps={{ hour: 1, minute: 1, second: 1 }}
                  onChange={handleCustomEndTimeChange}
                  style={{ width: "100%" }}
                />
              </>}
            </div>
          </>
        </BossDialog>
      )}

      {showPopups.updateComment && (
        <BossDialog
          title={comment.length > 0 ? lang.update_comment_actionbutton_menutext : lang.add_comment_actionbutton_menutext}
          width={"300px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="TabView">{lang.comment_label}</label>
              </div>
              <div className="col-12 form-group">
                <textarea className="pl-2"
                  type="text"
                  value={comment}
                  style={{ border: 'solid lightgrey 1px', height: '50px', width: '270px' }}
                  onChange={(e) => { setComment(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateProgramScheduleComment} onCancel={() => setShowPopups(defaultShowPopup)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {showPopups.addRouterCommand && (
        <BossDialog
          title={routerCommand.length > 0 ? lang.update_router_command_actionbutton_menutext : lang.add_router_command_actionbutton_menutext}
          width={"300px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <div className="row">
              <div className="col-12 form-group" style={{ marginBottom: 0 }}>
                <label htmlFor="TabView">{lang.router_command_label}</label>
              </div>
              <div className="col-12 form-group">
                <textarea className="pl-2"
                  type="text"
                  value={routerCommand}
                  style={{ border: 'solid lightgrey 1px', height: '50px', width: '270px' }}
                  onChange={(e) => { setRouterCommand(e.target.value) }}
                />
              </div>
            </div>
            <EditPageHeader title={""} onSubmit={onUpdateProgramScheduleRouterCommand} onCancel={() => setShowPopups(defaultShowPopup)} showTitle={false} />
          </>
        </BossDialog>
      )}

      {showPopups.showCustomDatesPopup && (
        <BossDialog
          title={lang.select_custom_date_range}
          width={"400px"}
          onClose={() => setShowPopups(defaultShowPopup)}
        >
          <>
            <div className="row">
              <div className="col-6 form-group">
                <label htmlFor="">{lang.start_date_label}</label>
                <input
                  className="form-control form-control-sm"
                  type="date"
                  value={customDates.startDate}
                  style={{ border: 'solid lightgrey 1px' }}
                  onChange={(e) => { setCustomDates({ ...customDates, startDate: e.target.value }) }}
                />
              </div>
              <div className="col-6 form-group" style={{ paddingLeft: '0px' }}>
                <label htmlFor="">{lang.end_Date_label}</label>
                <input
                  className="form-control form-control-sm"
                  type="date"
                  value={customDates.endDate}
                  style={{ border: 'solid lightgrey 1px' }}
                  onChange={(e) => { setCustomDates({ ...customDates, endDate: e.target.value }) }}
                />
              </div>
            </div>
            <EditPageHeader
              title={""}
              onSubmit={() => {
                setViewData("day");
                setShowPopups(defaultShowPopup);
                refreshPlanning();
              }}
              onCancel={() => setShowPopups(defaultShowPopup)}
              showTitle={false}
            />
          </>
        </BossDialog>
      )}

      {showCheckList &&
        <CheckLists
          customPayload={payloadRef.current}
          closeForm={onCheckList}
          data={dataRef.current.filter((item) => item.SlotDateTime >= getWeekDate.startDate && item.SlotDateTime <= getWeekDate.endDate)}
          module={MODULE.PLANNING}
        />
      }

      {showPopups.showAmortizationPopup &&
        <AmortisationValueReport selectedPlanningItem={focusedPlanningItemPropRef.current.dataItem} onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm} getSelectedChannel={getSelectedChannel} onClose={() => setShowPopups(defaultShowPopup)} />
      }
      {showPopups.showFormatSelection && (
        <CollectionSelection
          addButtonTitle={"Apply"}
          entityname={ENTITYNAME.Format}
          wherestatement={["Channel.SID", "=", filterChannels[selectedSlotRef.current.channelIndex].SID]}
          setDataList={onApplyFormatClick}
          closeForm={() => setShowPopups(defaultShowPopup)}
          existingItems={[]}
          checkDuplicate={false}
          mode={"single"}
          width="42vw"
        />
      )}
      {showPopups.showEditMetaDataPopup &&
        <PlanningMetaDataEditForm planningId={plannerSelectedItemsRef.current[0]?._id} onClose={() => {
          setShowPopups(defaultShowPopup)
        }} />
      }
      {showPopups.showRightSideEditForm && (
        isRightSide ? (
          <PlanningRightSideEditFormWithSlot
            dataItem={plannerSelectedItemsRef.current[0] || focusedPlanningItemPropRef.current.dataItem}
            onClose={() => setShowPopups(defaultShowPopup)}
            onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm}
            module={MODULE.PLANNING}
            customSlots={customSlots}
          />
        ) : (
          <PlanningEditFormWithSlot
            dataItem={plannerSelectedItemsRef.current[0] || focusedPlanningItemPropRef.current.dataItem}
            onClose={() => setShowPopups(defaultShowPopup)}
            onUpdateFromPlanningEditForm={onUpdateFromPlanningEditForm}
            module={MODULE.PLANNING}
            customSlots={customSlots}
          />
        )
      )}

      {headerLockPopup.show && <HeaderLockPopup onClose={(refresh = false) => {
        setHeaderLockPopup({ show: false, segments: [], header: null, nextHeaderStartTime: null });
        if (refresh) {
          refreshPlanning();
        }
      }} segments={headerLockPopup.segments} header={headerLockPopup.header} nextHeaderStartTime={headerLockPopup.nextHeaderStartTime} />
      }
      {showPublishToVodResultPopup && <ResponsePopup showPopup={showPublishToVodResultPopup} setShowPopup={setShowPublishToVodResultPopup} title={'VOD Publish Status'} results={publishResults} />}
      {assignNewTransmissionIdPopup.show && (
        <AssignNewTransmissionIdResponsePopup showPopup={assignNewTransmissionIdPopup.show} selectedItems={assignNewTransmissionIdPopup.selectedItems} updatedData={assignNewTransmissionIdPopup.updatedData}
          onClose={() => { setAssignNewTransmissionIdPopup({ show: false, selectedItems: [], updatedData: [] }); }}
        />
      )}

      {/* ProgramScheduleSlotEditForm – Create / Edit Slot Dialog */}
      {showCreateSlotPopup && (
        <ProgramScheduleSlotEditForm
          item={(() => {
            if (editingCustomSlot) {
              return editingCustomSlot;
            }
            const selectedChannel = filterChannels[selectedSlotRef.current?.channelIndex];
            const targetSlotTime = selectedSlotRef.current?.SlotDateTime
              ? new Date(selectedSlotRef.current.SlotDateTime.getTime() + offSetTime)
              : new Date();
            const slotStartMs = targetSlotTime.getTime();
            const slotEndMs = slotStartMs + ((slotDurationRef.current || 60) * 60000);
            return {
              Channel: selectedChannel || {},
              SlotDateTime: slotStartMs,
              SlotStart: slotStartMs,
              SlotEnd: slotEndMs,
              BgColor: "#4559bf",
              Description: "",
            };
          })()}
          cancelEdit={() => {
            setShowCreateSlotPopup(false);
            setEditingCustomSlot(null);
          }}
          onClose={() => {
            setShowCreateSlotPopup(false);
            setEditingCustomSlot(null);
          }}
          refresh={() => {
            setShowCreateSlotPopup(false);
            setEditingCustomSlot(null);
            refreshPlanning();
          }}
        />
      )}
      {/* CreateRecursiveSlotPopup – Recursive Slot Dialog */}
      {showCreateRecursiveSlotPopup && (
        <CreateRecursiveSlotPopup
          clickedSlot={clickedCustomSlotRef.current || clickedCustomSlot}
          selectedSlotTime={
            selectedSlotRef.current?.SlotDateTime
              ? new Date(selectedSlotRef.current.SlotDateTime.getTime() + offSetTime)
              : null
          }
          selectedChannel={filterChannels[selectedSlotRef.current?.channelIndex]}
          channels={filterChannels}
          onClose={() => {
            setShowCreateRecursiveSlotPopup(false);
          }}
          onSuccess={() => {
            setShowCreateRecursiveSlotPopup(false);
            refreshPlanning();
          }}
        />
      )}

      {/* Delete Linked Event Dialog for Recurring Custom Slots */}
      {showDeleteRecursiveDialog && (
        <BossDialog
          title="Delete Linked Event"
          width={"580px"}
          onClose={() => {
            setShowDeleteRecursiveDialog(false);
            setRecursiveSlotToDelete(null);
          }}
        >
          <div style={{ display: "grid", gap: "10px", padding: "4px 0" }}>
            {[
              {
                option: "SELECTED",
                label: "Delete Selected",
                message: "Selected item will be deleted and the slot will remain empty."
              },
              {
                option: "ALL",
                label: "Delete All Slots",
                message: "This will remove all recurring slots in this schedule pattern."
              },
              {
                option: "FORWARD",
                label: "Delete Slot Forward in the Strand",
                message: "This will remove all recurring slots from this selected slot forward in the strand."
              }
            ].map((item) => {
              const isSelected = selectedDeleteRecursiveOption === item.option;
              return (
                <div
                  key={item.option}
                  onClick={() => setSelectedDeleteRecursiveOption(item.option)}
                  style={{
                    display: "grid",
                    gridTemplateColumns: "auto 1fr",
                    gap: "12px",
                    alignItems: "flex-start",
                    padding: "10px 14px",
                    borderRadius: "10px",
                    border: isSelected ? "1.5px solid #2563eb" : "1px solid #e4e7eb",
                    backgroundColor: isSelected ? "#eff6ff" : "#ffffff",
                    cursor: "pointer",
                    transition: "all 0.15s ease"
                  }}
                >
                  <input
                    type="checkbox"
                    checked={isSelected}
                    onChange={() => setSelectedDeleteRecursiveOption(item.option)}
                    style={{
                      cursor: "pointer",
                      marginTop: "3px",
                      width: "16px",
                      height: "16px",
                      accentColor: "#2563eb"
                    }}
                  />
                  <div>
                    <div style={{ fontSize: "13px", fontWeight: 600, color: "#1e293b" }}>
                      {item.label}
                    </div>
                    <div style={{ fontSize: "11.5px", color: "#64748b", marginTop: "2px" }}>
                      {item.message}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div style={{ display: "flex", justifyContent: "flex-end", gap: "8px", marginTop: "16px" }}>
            <button
              type="button"
              className="btn btn-outline-secondary btn-sm"
              onClick={() => {
                setShowDeleteRecursiveDialog(false);
                setRecursiveSlotToDelete(null);
              }}
              style={{ minWidth: "80px", color: "#334155", borderColor: "#cbd5e1" }}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-dark btn-sm"
              onClick={onConfirmDeleteRecursiveSlot}
              style={{ minWidth: "80px", backgroundColor: "#334155", borderColor: "#334155", fontWeight: 600 }}
            >
              OK
            </button>
          </div>
        </BossDialog>
      )}

    </>
  );
};

export default memo(forwardRef(Planning_prformance));
